var items = {
  "block.minecraft.acacia_button": "Acacia Knop",
  "block.minecraft.acacia_door": "Acaciahouten duuer",
  "block.minecraft.acacia_fence": "Acaciahouten hek",
  "block.minecraft.acacia_fence_gate": "Acaciahouten peurtje",
  "block.minecraft.acacia_hanging_sign": "Acaciahouten hangbord",
  "block.minecraft.acacia_leaves": "Acaciablajere",
  "block.minecraft.acacia_log": "Acaciastjam",
  "block.minecraft.acacia_planks": "Acaciahouten plenk",
  "block.minecraft.acacia_pressure_plate": "Acacia Drukplaat",
  "block.minecraft.acacia_sapling": "Acaciakiemplant",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Acaciahouten bord",
  "block.minecraft.acacia_slab": "Acacia plaat",
  "block.minecraft.acacia_stairs": "Acaciahoute traeje",
  "block.minecraft.acacia_trapdoor": "Acaciahouten valloek",
  "block.minecraft.acacia_wall_hanging_sign": "Acaciahouten oethangbord",
  "block.minecraft.acacia_wall_sign": "Acaciahouten bord aon moor",
  "block.minecraft.acacia_wood": "Acaciahout",
  "block.minecraft.activator_rail": "Activatiespoear",
  "block.minecraft.air": "Locht",
  "block.minecraft.allium": "Look",
  "block.minecraft.amethyst_block": "Amethistblok",
  "block.minecraft.amethyst_cluster": "Amethistcluster",
  "block.minecraft.ancient_debris": "Alt puin",
  "block.minecraft.andesite": "Andesiet",
  "block.minecraft.andesite_slab": "Andesietplaat",
  "block.minecraft.andesite_stairs": "Andesiet traeje",
  "block.minecraft.andesite_wall": "Andesietmoer",
  "block.minecraft.anvil": "Aambild",
  "block.minecraft.attached_melon_stem": "Vastgezatte meloen sjtam",
  "block.minecraft.attached_pumpkin_stem": "Vastgezette Pompoensjtam",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azaleablajere",
  "block.minecraft.azure_bluet": "Porseleinsterretje",
  "block.minecraft.bamboo": "Bamboe",
  "block.minecraft.bamboo_block": "Bamboeblok",
  "block.minecraft.bamboo_button": "Bamboeknop",
  "block.minecraft.bamboo_door": "Bamboeduuer",
  "block.minecraft.bamboo_fence": "Bamboehek",
  "block.minecraft.bamboo_fence_gate": "Bamboepeurtje",
  "block.minecraft.bamboo_hanging_sign": "Bamboehangbord",
  "block.minecraft.bamboo_mosaic": "Bamboemozaïek",
  "block.minecraft.bamboo_mosaic_slab": "Bamboemozaïekplaat",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboemozaïektraeje",
  "block.minecraft.bamboo_planks": "Bamboeplenk",
  "block.minecraft.bamboo_pressure_plate": "Bamboedrukplaat",
  "block.minecraft.bamboo_sapling": "Bambooscheutje",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bamboebord",
  "block.minecraft.bamboo_slab": "Bamboeplaat",
  "block.minecraft.bamboo_stairs": "Bamboetraeje",
  "block.minecraft.bamboo_trapdoor": "Bamboevalloek",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboe-oethangbord",
  "block.minecraft.bamboo_wall_sign": "Bamboebord aon moor",
  "block.minecraft.banner.base.black": "Volledig zwart veld",
  "block.minecraft.banner.base.blue": "Volledig blauw veld",
  "block.minecraft.banner.base.brown": "Volledig broen veld",
  "block.minecraft.banner.base.cyan": "Volledig turquoise veld",
  "block.minecraft.banner.base.gray": "Volledig gries veld",
  "block.minecraft.banner.base.green": "Volledig greun veld",
  "block.minecraft.banner.base.light_blue": "Volledig licht blauw veld",
  "block.minecraft.banner.base.light_gray": "Volledig licht gries veld",
  "block.minecraft.banner.base.lime": "Volledig limoengreun veld",
  "block.minecraft.banner.base.magenta": "Volledig magenta veld",
  "block.minecraft.banner.base.orange": "Volledig oranje veld",
  "block.minecraft.banner.base.pink": "Volledig roze veld",
  "block.minecraft.banner.base.purple": "Volledig paars veld",
  "block.minecraft.banner.base.red": "Volledig roed veld",
  "block.minecraft.banner.base.white": "Volledig wit veld",
  "block.minecraft.banner.base.yellow": "Volledig geel veld",
  "block.minecraft.banner.border.black": "Zjwarte zoom",
  "block.minecraft.banner.border.blue": "Blauwe zoom",
  "block.minecraft.banner.border.brown": "Broene zoom",
  "block.minecraft.banner.border.cyan": "Turquoise zoom",
  "block.minecraft.banner.border.gray": "Grieze zoom",
  "block.minecraft.banner.border.green": "Greune zoom",
  "block.minecraft.banner.border.light_blue": "Leechtblauwe zoom",
  "block.minecraft.banner.border.light_gray": "Leechtgrieze zoom",
  "block.minecraft.banner.border.lime": "Limoengreune zoom",
  "block.minecraft.banner.border.magenta": "Magenta zoom",
  "block.minecraft.banner.border.orange": "Oranje zoom",
  "block.minecraft.banner.border.pink": "Roze zoom",
  "block.minecraft.banner.border.purple": "Paarse zoom",
  "block.minecraft.banner.border.red": "Roede zoom",
  "block.minecraft.banner.border.white": "Witte zoom",
  "block.minecraft.banner.border.yellow": "Gaele zoom",
  "block.minecraft.banner.bricks.black": "Zwart metselwerk",
  "block.minecraft.banner.bricks.blue": "Blauw metselwerk",
  "block.minecraft.banner.bricks.brown": "Broen metselwerk",
  "block.minecraft.banner.bricks.cyan": "Turquoise metselwerk",
  "block.minecraft.banner.bricks.gray": "Gries metselwerk",
  "block.minecraft.banner.bricks.green": "Greun metselwerk",
  "block.minecraft.banner.bricks.light_blue": "Leechtblauw metselwerk",
  "block.minecraft.banner.bricks.light_gray": "Leechtgries metselwerk",
  "block.minecraft.banner.bricks.lime": "Limoengreun metselwerk",
  "block.minecraft.banner.bricks.magenta": "Magenta metselwerk",
  "block.minecraft.banner.bricks.orange": "Oranje metselwerk",
  "block.minecraft.banner.bricks.pink": "Roze metselwerk",
  "block.minecraft.banner.bricks.purple": "Blauw metselwerk",
  "block.minecraft.banner.bricks.red": "Roed metselwerk",
  "block.minecraft.banner.bricks.white": "Wit metselwerk",
  "block.minecraft.banner.bricks.yellow": "Gael metselwerk",
  "block.minecraft.banner.circle.black": "Zjwart rozet",
  "block.minecraft.banner.circle.blue": "Blauw rozet",
  "block.minecraft.banner.circle.brown": "Broen rozet",
  "block.minecraft.banner.circle.cyan": "Turquoise rozet",
  "block.minecraft.banner.circle.gray": "Gries rozet",
  "block.minecraft.banner.circle.green": "Greun rozet",
  "block.minecraft.banner.circle.light_blue": "Leechtblauw rozet",
  "block.minecraft.banner.circle.light_gray": "Leechtgries rozet",
  "block.minecraft.banner.circle.lime": "Limoengreun rozet",
  "block.minecraft.banner.circle.magenta": "Magenta rozet",
  "block.minecraft.banner.circle.orange": "Oranje rozet",
  "block.minecraft.banner.circle.pink": "Roze rozet",
  "block.minecraft.banner.circle.purple": "Paars rozet",
  "block.minecraft.banner.circle.red": "Roed rozet",
  "block.minecraft.banner.circle.white": "Wit rozet",
  "block.minecraft.banner.circle.yellow": "Gael rozet",
  "block.minecraft.banner.creeper.black": "Zjwart creeperwapen",
  "block.minecraft.banner.creeper.blue": "Blauw creeperwapen",
  "block.minecraft.banner.creeper.brown": "Breun creeperwapen",
  "block.minecraft.banner.creeper.cyan": "Turquoise Creeper",
  "block.minecraft.banner.creeper.gray": "Gries creeperwapen",
  "block.minecraft.banner.creeper.green": "Greun creeperwapen",
  "block.minecraft.banner.creeper.light_blue": "Leechtblauw creeperwapen",
  "block.minecraft.banner.creeper.light_gray": "Leechtgries creeperwapen",
  "block.minecraft.banner.creeper.lime": "Limoengreun creeperwapen",
  "block.minecraft.banner.creeper.magenta": "Magenta creeperwapen",
  "block.minecraft.banner.creeper.orange": "Oranje creeperwapen",
  "block.minecraft.banner.creeper.pink": "Roze creeperwapen",
  "block.minecraft.banner.creeper.purple": "Paars creeperwapen",
  "block.minecraft.banner.creeper.red": "Roed creeperwapen",
  "block.minecraft.banner.creeper.white": "Wit creeperwapen",
  "block.minecraft.banner.creeper.yellow": "Gael creeperwapen",
  "block.minecraft.banner.cross.black": "Zjwart andreaskroes",
  "block.minecraft.banner.cross.blue": "Blauw andreaskroes",
  "block.minecraft.banner.cross.brown": "Broen andreaskroes",
  "block.minecraft.banner.cross.cyan": "Turquoise andreaskroes",
  "block.minecraft.banner.cross.gray": "Gries andreaskroes",
  "block.minecraft.banner.cross.green": "Greun andreaskoes",
  "block.minecraft.banner.cross.light_blue": "Leechtblauw andreaskroes",
  "block.minecraft.banner.cross.light_gray": "Leechtgries andreaskroes",
  "block.minecraft.banner.cross.lime": "Limoengreun andreaskroes",
  "block.minecraft.banner.cross.magenta": "Magenta andreaskroes",
  "block.minecraft.banner.cross.orange": "Oranje andreaskroes",
  "block.minecraft.banner.cross.pink": "Roze andreaskroes",
  "block.minecraft.banner.cross.purple": "Paars andreaskoes",
  "block.minecraft.banner.cross.red": "Roed andreaskroes",
  "block.minecraft.banner.cross.white": "Wit andreaskroes",
  "block.minecraft.banner.cross.yellow": "Gael andreaskroes",
  "block.minecraft.banner.curly_border.black": "Zjwarte ingesprongen zoom",
  "block.minecraft.banner.curly_border.blue": "Blauwe ingesprongen zoom",
  "block.minecraft.banner.curly_border.brown": "Broene ingesprongen zoom",
  "block.minecraft.banner.curly_border.cyan": "Turquoise ingesprongen zoom",
  "block.minecraft.banner.curly_border.gray": "Grieze ingesprongen zoom",
  "block.minecraft.banner.curly_border.green": "Greune ingesprongen zoom",
  "block.minecraft.banner.curly_border.light_blue": "Leechtblauwe ingesprongen zoom",
  "block.minecraft.banner.curly_border.light_gray": "Leechtgrieze ingesprongen zoom",
  "block.minecraft.banner.curly_border.lime": "Limoengreune ingesprongen zoom",
  "block.minecraft.banner.curly_border.magenta": "Magenta ingesprongen zoom",
  "block.minecraft.banner.curly_border.orange": "Oranje ingesprongen zoom",
  "block.minecraft.banner.curly_border.pink": "Roze ingesprongen zoom",
  "block.minecraft.banner.curly_border.purple": "Paarse ingesprongen zoom",
  "block.minecraft.banner.curly_border.red": "Roede ingesprongen zoom",
  "block.minecraft.banner.curly_border.white": "Witte ingesprongen zoom",
  "block.minecraft.banner.curly_border.yellow": "Gaele ingesprongen zoom",
  "block.minecraft.banner.diagonal_left.black": "Zjwarte per band sinister",
  "block.minecraft.banner.diagonal_left.blue": "Blauwe per band sinister",
  "block.minecraft.banner.diagonal_left.brown": "Broene per band sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Turquoise per band sinister",
  "block.minecraft.banner.diagonal_left.gray": "Grieze per band sinister",
  "block.minecraft.banner.diagonal_left.green": "Greune per band sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Leechtblauwe per band omgekeerd",
  "block.minecraft.banner.diagonal_left.light_gray": "Leechtgrieze per band omgekeerd",
  "block.minecraft.banner.diagonal_left.lime": "Limoengreune per band sinister",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta per band sinister",
  "block.minecraft.banner.diagonal_left.orange": "Oranje per band sinister",
  "block.minecraft.banner.diagonal_left.pink": "Roze per band sinister",
  "block.minecraft.banner.diagonal_left.purple": "Paarse per band sinister",
  "block.minecraft.banner.diagonal_left.red": "Roede per band sinister",
  "block.minecraft.banner.diagonal_left.white": "Witte per band sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Gaele per band sinister",
  "block.minecraft.banner.diagonal_right.black": "Zjwarte per band",
  "block.minecraft.banner.diagonal_right.blue": "Blauwe per band",
  "block.minecraft.banner.diagonal_right.brown": "Broene per band",
  "block.minecraft.banner.diagonal_right.cyan": "Turquoise per band",
  "block.minecraft.banner.diagonal_right.gray": "Grieze per band",
  "block.minecraft.banner.diagonal_right.green": "Greune per band",
  "block.minecraft.banner.diagonal_right.light_blue": "Leechtblauwe per band",
  "block.minecraft.banner.diagonal_right.light_gray": "Leechtgrieze per band",
  "block.minecraft.banner.diagonal_right.lime": "Limoengreune per band",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta per band",
  "block.minecraft.banner.diagonal_right.orange": "Oranje per band",
  "block.minecraft.banner.diagonal_right.pink": "Roze per band",
  "block.minecraft.banner.diagonal_right.purple": "Paarse per band",
  "block.minecraft.banner.diagonal_right.red": "Roede per band",
  "block.minecraft.banner.diagonal_right.white": "Witte per band",
  "block.minecraft.banner.diagonal_right.yellow": "Gaele per band",
  "block.minecraft.banner.diagonal_up_left.black": "Zjwarte per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.blue": "Blauwe per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.brown": "Broene per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turquoise per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.gray": "Grieze per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.green": "Greune per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Leechtblauwe per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Leechtgrieze per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.lime": "Limoengreune per band omgekierd",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranje per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.pink": "Roze per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.purple": "Paarse per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.red": "Roede per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.white": "Witte per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gaele per band omgekeerd",
  "block.minecraft.banner.diagonal_up_right.black": "Zjwarte per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.blue": "Blauwe per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.brown": "Bruine per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turquoise per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.gray": "Griese per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.green": "Greune per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Leechtblauwe per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Leechtgrieze per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.lime": "Limoengreune per band sinister omgekierd",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranje per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.pink": "Roze per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.purple": "Paarse per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.red": "Roede Per Bocht Sinister Omgekeerd",
  "block.minecraft.banner.diagonal_up_right.white": "Witte per band sinister omgekeerd",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gele per band sinister omgekeerd",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Zjwart bloomwapen",
  "block.minecraft.banner.flower.blue": "Blauw bloomwapen",
  "block.minecraft.banner.flower.brown": "Broen bloomwapen",
  "block.minecraft.banner.flower.cyan": "Turquoise bloomwapen",
  "block.minecraft.banner.flower.gray": "Gries bloomwapen",
  "block.minecraft.banner.flower.green": "Greun bloomwapen",
  "block.minecraft.banner.flower.light_blue": "Leechtblauw bloemwapen",
  "block.minecraft.banner.flower.light_gray": "Leechtgries bloemwapen",
  "block.minecraft.banner.flower.lime": "Limoengreun bloemwapen",
  "block.minecraft.banner.flower.magenta": "Magenta bloomwapen",
  "block.minecraft.banner.flower.orange": "Oranje bloomwapen",
  "block.minecraft.banner.flower.pink": "Roze bloomwapen",
  "block.minecraft.banner.flower.purple": "Paars bloomwapen",
  "block.minecraft.banner.flower.red": "Roed bloomwapen",
  "block.minecraft.banner.flower.white": "Wit bloomwapen",
  "block.minecraft.banner.flower.yellow": "Gael bloomwapen",
  "block.minecraft.banner.globe.black": "Zjwarte globe",
  "block.minecraft.banner.globe.blue": "Blauwe globe",
  "block.minecraft.banner.globe.brown": "Broene globe",
  "block.minecraft.banner.globe.cyan": "Turquoise globe",
  "block.minecraft.banner.globe.gray": "Grieze globe",
  "block.minecraft.banner.globe.green": "Greune globe",
  "block.minecraft.banner.globe.light_blue": "Leechtblauwe bol",
  "block.minecraft.banner.globe.light_gray": "Leechtgrieze bol",
  "block.minecraft.banner.globe.lime": "Limoengreune aarde",
  "block.minecraft.banner.globe.magenta": "Magenta Bol",
  "block.minecraft.banner.globe.orange": "Oranje Globe",
  "block.minecraft.banner.globe.pink": "Roze globe",
  "block.minecraft.banner.globe.purple": "Poarse Bol",
  "block.minecraft.banner.globe.red": "Roeje Bol",
  "block.minecraft.banner.globe.white": "Witte globe",
  "block.minecraft.banner.globe.yellow": "Gaele globe",
  "block.minecraft.banner.gradient.black": "Zjwart gradiënt",
  "block.minecraft.banner.gradient.blue": "Blauw gradiënt",
  "block.minecraft.banner.gradient.brown": "Broen gradiënt",
  "block.minecraft.banner.gradient.cyan": "Turquoise gradiënt",
  "block.minecraft.banner.gradient.gray": "Gries gradiënt",
  "block.minecraft.banner.gradient.green": "Greun gradiënt",
  "block.minecraft.banner.gradient.light_blue": "Leechtblauw gradiënt",
  "block.minecraft.banner.gradient.light_gray": "Leechtgries gradiënt",
  "block.minecraft.banner.gradient.lime": "Limoengreun gradiënt",
  "block.minecraft.banner.gradient.magenta": "Magenta gradiënt",
  "block.minecraft.banner.gradient.orange": "Oranje gradiënt",
  "block.minecraft.banner.gradient.pink": "Roze gradiënt",
  "block.minecraft.banner.gradient.purple": "Paars gradiënt",
  "block.minecraft.banner.gradient.red": "Roed gradiënt",
  "block.minecraft.banner.gradient.white": "Wit gradiënt",
  "block.minecraft.banner.gradient.yellow": "Gael gradiënt",
  "block.minecraft.banner.gradient_up.black": "Zjwart basis gradiënt",
  "block.minecraft.banner.gradient_up.blue": "Blauw basis gradiënt",
  "block.minecraft.banner.gradient_up.brown": "Broen basis gradiënt",
  "block.minecraft.banner.gradient_up.cyan": "Turquoise basis gradiënt",
  "block.minecraft.banner.gradient_up.gray": "Gries basis gradiënt",
  "block.minecraft.banner.gradient_up.green": "Greun basis gradiënt",
  "block.minecraft.banner.gradient_up.light_blue": "Leechtblauw basis gradiënt",
  "block.minecraft.banner.gradient_up.light_gray": "Leechtgries basis gradiënt",
  "block.minecraft.banner.gradient_up.lime": "Limoengreun basisgradiënt",
  "block.minecraft.banner.gradient_up.magenta": "Magenta basis gradiënt",
  "block.minecraft.banner.gradient_up.orange": "Oranje basis gradiënt",
  "block.minecraft.banner.gradient_up.pink": "Roze basis gradiënt",
  "block.minecraft.banner.gradient_up.purple": "Paars basis gradiënt",
  "block.minecraft.banner.gradient_up.red": "Roed basis gradiënt",
  "block.minecraft.banner.gradient_up.white": "Wit basis gradiënt",
  "block.minecraft.banner.gradient_up.yellow": "Gael basis gradiënt",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Zjwarte per faas",
  "block.minecraft.banner.half_horizontal.blue": "Blauwe per faas",
  "block.minecraft.banner.half_horizontal.brown": "Broene per faas",
  "block.minecraft.banner.half_horizontal.cyan": "Turquoise per faas",
  "block.minecraft.banner.half_horizontal.gray": "Grieze per faas",
  "block.minecraft.banner.half_horizontal.green": "Greune per faas",
  "block.minecraft.banner.half_horizontal.light_blue": "Leechtblauwe per faas",
  "block.minecraft.banner.half_horizontal.light_gray": "Leechtgrieze per faas",
  "block.minecraft.banner.half_horizontal.lime": "Limoengreune per faas",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta per faas",
  "block.minecraft.banner.half_horizontal.orange": "Oranje per faas",
  "block.minecraft.banner.half_horizontal.pink": "Roze per faas",
  "block.minecraft.banner.half_horizontal.purple": "Paarse per faas",
  "block.minecraft.banner.half_horizontal.red": "Roede per faas",
  "block.minecraft.banner.half_horizontal.white": "Witte per faas",
  "block.minecraft.banner.half_horizontal.yellow": "Gaele per faas",
  "block.minecraft.banner.half_horizontal_bottom.black": "Zjwarte per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blauwe per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Broene per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turquoise per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grieze per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.green": "Greune Per Fess Omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Leechtblauwe per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Leechtgrieze per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Limoengreune per faas omgekierd",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranje per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roze per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Paarse per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.red": "Roede per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.white": "Witte per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gaele per faas omgekeerd",
  "block.minecraft.banner.half_vertical.black": "Zjwarte per päöl",
  "block.minecraft.banner.half_vertical.blue": "Blauwe per päöl",
  "block.minecraft.banner.half_vertical.brown": "Broene per päöl",
  "block.minecraft.banner.half_vertical.cyan": "Turquoise per päöl",
  "block.minecraft.banner.half_vertical.gray": "Grieze per päöl",
  "block.minecraft.banner.half_vertical.green": "Greune per päöl",
  "block.minecraft.banner.half_vertical.light_blue": "Leechtblauwe per päöl",
  "block.minecraft.banner.half_vertical.light_gray": "Leechtgrieze per päöl",
  "block.minecraft.banner.half_vertical.lime": "Limoengreune per päöl",
  "block.minecraft.banner.half_vertical.magenta": "Magenta per päöl",
  "block.minecraft.banner.half_vertical.orange": "Oranje per päöl",
  "block.minecraft.banner.half_vertical.pink": "Roze per päöl",
  "block.minecraft.banner.half_vertical.purple": "Paarse per päöl",
  "block.minecraft.banner.half_vertical.red": "Roede per päöl",
  "block.minecraft.banner.half_vertical.white": "Witte per päöl",
  "block.minecraft.banner.half_vertical.yellow": "Gaele per päöl",
  "block.minecraft.banner.half_vertical_right.black": "Zjwarte per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.blue": "Blauwe per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.brown": "Broene per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.cyan": "Turquoise per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.gray": "Grieze per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.green": "Greune per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.light_blue": "Leechtblauwe per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.light_gray": "Leechtgrieze per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.lime": "Limoengreune per päöl omgekierd",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.orange": "Oranje per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.pink": "Roze per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.purple": "Paarse per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.red": "Roede per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.white": "Witte per päöl omgekeerd",
  "block.minecraft.banner.half_vertical_right.yellow": "Gaele per päöl omgekeerd",
  "block.minecraft.banner.mojang.black": "Zjwart Mojangwapen",
  "block.minecraft.banner.mojang.blue": "Blauw Mojangwapen",
  "block.minecraft.banner.mojang.brown": "Broen Mojangwapen",
  "block.minecraft.banner.mojang.cyan": "Turquoise Mojangwapen",
  "block.minecraft.banner.mojang.gray": "Gries Mojangwapen",
  "block.minecraft.banner.mojang.green": "Greun Mojangwapen",
  "block.minecraft.banner.mojang.light_blue": "Leechtblauw Mojangwapen",
  "block.minecraft.banner.mojang.light_gray": "Leechtgries Mojangwapen",
  "block.minecraft.banner.mojang.lime": "Limoengreun Mojangwapen",
  "block.minecraft.banner.mojang.magenta": "Magenta Mojangwapen",
  "block.minecraft.banner.mojang.orange": "Oranje Mojangwapen",
  "block.minecraft.banner.mojang.pink": "Roze Mojangwapen",
  "block.minecraft.banner.mojang.purple": "Paars Mojangwapen",
  "block.minecraft.banner.mojang.red": "Roed Mojangwapen",
  "block.minecraft.banner.mojang.white": "Wit Mojangwapen",
  "block.minecraft.banner.mojang.yellow": "Gael Mojangwapen",
  "block.minecraft.banner.piglin.black": "Zwarte snoet",
  "block.minecraft.banner.piglin.blue": "Blauwe snoet",
  "block.minecraft.banner.piglin.brown": "Broene snoet",
  "block.minecraft.banner.piglin.cyan": "Turquoise snoet",
  "block.minecraft.banner.piglin.gray": "Grieze snoet",
  "block.minecraft.banner.piglin.green": "Greune snoet",
  "block.minecraft.banner.piglin.light_blue": "Leechtblauwe snoet",
  "block.minecraft.banner.piglin.light_gray": "Leechtgrieze snoet",
  "block.minecraft.banner.piglin.lime": "Limoengreune snoet",
  "block.minecraft.banner.piglin.magenta": "Magenta snoet",
  "block.minecraft.banner.piglin.orange": "Oranje snoet",
  "block.minecraft.banner.piglin.pink": "Roze snoet",
  "block.minecraft.banner.piglin.purple": "Paarse snoet",
  "block.minecraft.banner.piglin.red": "Roeie snoet",
  "block.minecraft.banner.piglin.white": "Witte snoet",
  "block.minecraft.banner.piglin.yellow": "Gaele snoet",
  "block.minecraft.banner.rhombus.black": "Zjwart roet",
  "block.minecraft.banner.rhombus.blue": "Blauwe roet",
  "block.minecraft.banner.rhombus.brown": "Broene roet",
  "block.minecraft.banner.rhombus.cyan": "Turquoise roet",
  "block.minecraft.banner.rhombus.gray": "Grieze roet",
  "block.minecraft.banner.rhombus.green": "Greune roet",
  "block.minecraft.banner.rhombus.light_blue": "Leechtblauwe roet",
  "block.minecraft.banner.rhombus.light_gray": "Leechtgrieze roet",
  "block.minecraft.banner.rhombus.lime": "Limoengreune roet",
  "block.minecraft.banner.rhombus.magenta": "Magenta roet",
  "block.minecraft.banner.rhombus.orange": "Oranje roet",
  "block.minecraft.banner.rhombus.pink": "Roze roet",
  "block.minecraft.banner.rhombus.purple": "Paarse roet",
  "block.minecraft.banner.rhombus.red": "Roede roet",
  "block.minecraft.banner.rhombus.white": "Witte roet",
  "block.minecraft.banner.rhombus.yellow": "Gaele roet",
  "block.minecraft.banner.skull.black": "Zjwart schedelwapen",
  "block.minecraft.banner.skull.blue": "Blauw schedelwapen",
  "block.minecraft.banner.skull.brown": "Broen schedelwapen",
  "block.minecraft.banner.skull.cyan": "Turquoise schedelwapen",
  "block.minecraft.banner.skull.gray": "Gries schedelwapen",
  "block.minecraft.banner.skull.green": "Greun schedelwapen",
  "block.minecraft.banner.skull.light_blue": "Leechtblauw schedelwapen",
  "block.minecraft.banner.skull.light_gray": "Leechtgries schedelwapen",
  "block.minecraft.banner.skull.lime": "Limoengreun schedelwapen",
  "block.minecraft.banner.skull.magenta": "Magenta schedelwapen",
  "block.minecraft.banner.skull.orange": "Oranje schedelwapen",
  "block.minecraft.banner.skull.pink": "Roze schedelwapen",
  "block.minecraft.banner.skull.purple": "Paars schedelwapen",
  "block.minecraft.banner.skull.red": "Roed schedelwapen",
  "block.minecraft.banner.skull.white": "Wit schedelwapen",
  "block.minecraft.banner.skull.yellow": "Gael schedelwapen",
  "block.minecraft.banner.small_stripes.black": "Zjwarte paly",
  "block.minecraft.banner.small_stripes.blue": "Blauwe paly",
  "block.minecraft.banner.small_stripes.brown": "Broene paly",
  "block.minecraft.banner.small_stripes.cyan": "Turquoise paly",
  "block.minecraft.banner.small_stripes.gray": "Grieze paly",
  "block.minecraft.banner.small_stripes.green": "Greune paly",
  "block.minecraft.banner.small_stripes.light_blue": "Leechtblauwe paly",
  "block.minecraft.banner.small_stripes.light_gray": "Leechtgrieze paly",
  "block.minecraft.banner.small_stripes.lime": "Limoengreune paole",
  "block.minecraft.banner.small_stripes.magenta": "Magenta paly",
  "block.minecraft.banner.small_stripes.orange": "Oranje paly",
  "block.minecraft.banner.small_stripes.pink": "Roze paly",
  "block.minecraft.banner.small_stripes.purple": "Paarse paly",
  "block.minecraft.banner.small_stripes.red": "Roede paly",
  "block.minecraft.banner.small_stripes.white": "Witte paly",
  "block.minecraft.banner.small_stripes.yellow": "Gaele paly",
  "block.minecraft.banner.square_bottom_left.black": "Zjwart basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.blue": "Blauw basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.brown": "Broen basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.cyan": "Turquoise basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.gray": "Gries basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.green": "Greun basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Leechtblauw basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.light_gray": "Leechtgries basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.lime": "Limoengreun basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.orange": "Oranje basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.pink": "Roze basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.purple": "Paars basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.red": "Roed basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.white": "Wit basis dexter kanton",
  "block.minecraft.banner.square_bottom_left.yellow": "Gael basis dexter kanton",
  "block.minecraft.banner.square_bottom_right.black": "Zjwart basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.blue": "Blauw basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.brown": "Broen basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.cyan": "Turquoise basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.gray": "Gries basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.green": "Greun basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Leechtblauw Basis Sinister Kanton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Leechtgries Basis Sinister Kanton",
  "block.minecraft.banner.square_bottom_right.lime": "Limoengreun basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.orange": "Oranje basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.pink": "Roze basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.purple": "Paars basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.red": "Roed basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.white": "Wit basis sinister kanton",
  "block.minecraft.banner.square_bottom_right.yellow": "Gael basis sinister kanton",
  "block.minecraft.banner.square_top_left.black": "Zjwart hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.blue": "Blauw hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.brown": "Broen hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.cyan": "Turquoise hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.gray": "Gries hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.green": "Greun hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.light_blue": "Leechtblauw hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.light_gray": "Leechtgries hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.lime": "Limoengreun hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.magenta": "Magenta hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.orange": "Oranje hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.pink": "Roze hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.purple": "Paars hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.red": "Roed hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.white": "Wit hoofd dexter kanton",
  "block.minecraft.banner.square_top_left.yellow": "Gael hoofd dexter kanton",
  "block.minecraft.banner.square_top_right.black": "Zjwart hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.blue": "Blauw hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.brown": "Broen hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.cyan": "Turquoise hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.gray": "Gries hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.green": "Greun hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.light_blue": "Leechtblauw Hoofd Sinister Kanton",
  "block.minecraft.banner.square_top_right.light_gray": "Leechtgries Hoofd Sinister Kanton",
  "block.minecraft.banner.square_top_right.lime": "Limoengreun hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.magenta": "Magenta hoofd dexter kanton",
  "block.minecraft.banner.square_top_right.orange": "Oranje hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.pink": "Roze hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.purple": "Paars hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.red": "Roed hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.white": "Wit hoofd sinister kanton",
  "block.minecraft.banner.square_top_right.yellow": "Gael hoofd sinister kanton",
  "block.minecraft.banner.straight_cross.black": "Zjwart kroes",
  "block.minecraft.banner.straight_cross.blue": "Blauw kroes",
  "block.minecraft.banner.straight_cross.brown": "Broen kroes",
  "block.minecraft.banner.straight_cross.cyan": "Turquoise kroes",
  "block.minecraft.banner.straight_cross.gray": "Gries kroes",
  "block.minecraft.banner.straight_cross.green": "Greun kroes",
  "block.minecraft.banner.straight_cross.light_blue": "Leechtblauw kroes",
  "block.minecraft.banner.straight_cross.light_gray": "Leechtgries kroes",
  "block.minecraft.banner.straight_cross.lime": "Limoengreun kroes",
  "block.minecraft.banner.straight_cross.magenta": "Magenta kroes",
  "block.minecraft.banner.straight_cross.orange": "Oranje kroes",
  "block.minecraft.banner.straight_cross.pink": "Roze kroes",
  "block.minecraft.banner.straight_cross.purple": "Paars kroes",
  "block.minecraft.banner.straight_cross.red": "Roed kroes",
  "block.minecraft.banner.straight_cross.white": "Wit kroes",
  "block.minecraft.banner.straight_cross.yellow": "Gael kroes",
  "block.minecraft.banner.stripe_bottom.black": "Zjwarte basis",
  "block.minecraft.banner.stripe_bottom.blue": "Blauwe basis",
  "block.minecraft.banner.stripe_bottom.brown": "Broene basis",
  "block.minecraft.banner.stripe_bottom.cyan": "Turquoise basis",
  "block.minecraft.banner.stripe_bottom.gray": "Grieze basis",
  "block.minecraft.banner.stripe_bottom.green": "Greune basis",
  "block.minecraft.banner.stripe_bottom.light_blue": "Leechtblauwe basis",
  "block.minecraft.banner.stripe_bottom.light_gray": "Leechtgrieze basis",
  "block.minecraft.banner.stripe_bottom.lime": "Limoengreune basis",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta basis",
  "block.minecraft.banner.stripe_bottom.orange": "Oranje basis",
  "block.minecraft.banner.stripe_bottom.pink": "Roze basis",
  "block.minecraft.banner.stripe_bottom.purple": "Paarse basis",
  "block.minecraft.banner.stripe_bottom.red": "Roede basis",
  "block.minecraft.banner.stripe_bottom.white": "Witte basis",
  "block.minecraft.banner.stripe_bottom.yellow": "Gaele basis",
  "block.minecraft.banner.stripe_center.black": "Zjwarte päöl",
  "block.minecraft.banner.stripe_center.blue": "Blauwe päöl",
  "block.minecraft.banner.stripe_center.brown": "Broene päöl",
  "block.minecraft.banner.stripe_center.cyan": "Turquoise päöl",
  "block.minecraft.banner.stripe_center.gray": "Grieze päöl",
  "block.minecraft.banner.stripe_center.green": "Greune päöl",
  "block.minecraft.banner.stripe_center.light_blue": "Leechtblauwe päöl",
  "block.minecraft.banner.stripe_center.light_gray": "Leechtgrieze päöl",
  "block.minecraft.banner.stripe_center.lime": "Limoengreune päöl",
  "block.minecraft.banner.stripe_center.magenta": "Magenta päöl",
  "block.minecraft.banner.stripe_center.orange": "Oranje päöl",
  "block.minecraft.banner.stripe_center.pink": "Roze päöl",
  "block.minecraft.banner.stripe_center.purple": "Paarse päöl",
  "block.minecraft.banner.stripe_center.red": "Roede päöl",
  "block.minecraft.banner.stripe_center.white": "Witte päöl",
  "block.minecraft.banner.stripe_center.yellow": "Gaele päöl",
  "block.minecraft.banner.stripe_downleft.black": "Zjwarte band sinister",
  "block.minecraft.banner.stripe_downleft.blue": "Blauwe band sinister",
  "block.minecraft.banner.stripe_downleft.brown": "Broene band sinister",
  "block.minecraft.banner.stripe_downleft.cyan": "Turquoise band sinister",
  "block.minecraft.banner.stripe_downleft.gray": "Grieze band sinister",
  "block.minecraft.banner.stripe_downleft.green": "Greune band sinister",
  "block.minecraft.banner.stripe_downleft.light_blue": "Leechtblauwe band sinister",
  "block.minecraft.banner.stripe_downleft.light_gray": "Leechtgrieze band sinister",
  "block.minecraft.banner.stripe_downleft.lime": "Limoengreune band sinister",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Bocht Sinister",
  "block.minecraft.banner.stripe_downleft.orange": "Oranje band sinister",
  "block.minecraft.banner.stripe_downleft.pink": "Roze band sinister",
  "block.minecraft.banner.stripe_downleft.purple": "Paarse band sinister",
  "block.minecraft.banner.stripe_downleft.red": "Roede band sinister",
  "block.minecraft.banner.stripe_downleft.white": "Witte band sinister",
  "block.minecraft.banner.stripe_downleft.yellow": "Gaele band sinister",
  "block.minecraft.banner.stripe_downright.black": "Zjwarte band",
  "block.minecraft.banner.stripe_downright.blue": "Blauwe band",
  "block.minecraft.banner.stripe_downright.brown": "Broene band",
  "block.minecraft.banner.stripe_downright.cyan": "Turquoise band",
  "block.minecraft.banner.stripe_downright.gray": "Grieze band",
  "block.minecraft.banner.stripe_downright.green": "Greune band",
  "block.minecraft.banner.stripe_downright.light_blue": "Leechtblauwe band",
  "block.minecraft.banner.stripe_downright.light_gray": "Leechtgrieze band",
  "block.minecraft.banner.stripe_downright.lime": "Limoengreune band",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta band",
  "block.minecraft.banner.stripe_downright.orange": "Oranje band",
  "block.minecraft.banner.stripe_downright.pink": "Roze band",
  "block.minecraft.banner.stripe_downright.purple": "Paarse band",
  "block.minecraft.banner.stripe_downright.red": "Roede band",
  "block.minecraft.banner.stripe_downright.white": "Witte band",
  "block.minecraft.banner.stripe_downright.yellow": "Gaele band",
  "block.minecraft.banner.stripe_left.black": "Zjwarte päöl dexter",
  "block.minecraft.banner.stripe_left.blue": "Blauwe päöl dexter",
  "block.minecraft.banner.stripe_left.brown": "Broene päöl dexter",
  "block.minecraft.banner.stripe_left.cyan": "Turquoise päöl dexter",
  "block.minecraft.banner.stripe_left.gray": "Grieze päöl dexter",
  "block.minecraft.banner.stripe_left.green": "Greune päöl dexter",
  "block.minecraft.banner.stripe_left.light_blue": "Leechtblauwe päöl dexter",
  "block.minecraft.banner.stripe_left.light_gray": "Leechtgrieze päöl dexter",
  "block.minecraft.banner.stripe_left.lime": "Limoengreune päöl dexter",
  "block.minecraft.banner.stripe_left.magenta": "Magenta päöl dexter",
  "block.minecraft.banner.stripe_left.orange": "Oranje päöl dexter",
  "block.minecraft.banner.stripe_left.pink": "Roze päöl dexter",
  "block.minecraft.banner.stripe_left.purple": "Paarse päöl dexter",
  "block.minecraft.banner.stripe_left.red": "Roede päöl dexter",
  "block.minecraft.banner.stripe_left.white": "Witte päöl dexter",
  "block.minecraft.banner.stripe_left.yellow": "Gaele päöl dexter",
  "block.minecraft.banner.stripe_middle.black": "Zjwarte faas",
  "block.minecraft.banner.stripe_middle.blue": "Blauwe faas",
  "block.minecraft.banner.stripe_middle.brown": "Broene faas",
  "block.minecraft.banner.stripe_middle.cyan": "Turquoise faas",
  "block.minecraft.banner.stripe_middle.gray": "Grieze faas",
  "block.minecraft.banner.stripe_middle.green": "Greune faas",
  "block.minecraft.banner.stripe_middle.light_blue": "Leechtblauwe faas",
  "block.minecraft.banner.stripe_middle.light_gray": "Leechtgrieze faas",
  "block.minecraft.banner.stripe_middle.lime": "Limoengreune faas",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta faas",
  "block.minecraft.banner.stripe_middle.orange": "Oranje faas",
  "block.minecraft.banner.stripe_middle.pink": "Roze faas",
  "block.minecraft.banner.stripe_middle.purple": "Paarse faas",
  "block.minecraft.banner.stripe_middle.red": "Roede faas",
  "block.minecraft.banner.stripe_middle.white": "Witte faas",
  "block.minecraft.banner.stripe_middle.yellow": "Gaele faas",
  "block.minecraft.banner.stripe_right.black": "Zjwarte päöl sinister",
  "block.minecraft.banner.stripe_right.blue": "Blauwe päöl sinister",
  "block.minecraft.banner.stripe_right.brown": "Broene päöl sinister",
  "block.minecraft.banner.stripe_right.cyan": "Turquoise päöl sinister",
  "block.minecraft.banner.stripe_right.gray": "Griese päöl sinister",
  "block.minecraft.banner.stripe_right.green": "Greune päöl sinister",
  "block.minecraft.banner.stripe_right.light_blue": "Leechtblauwe päöl sinister",
  "block.minecraft.banner.stripe_right.light_gray": "Leechtgrieze päöl sinister",
  "block.minecraft.banner.stripe_right.lime": "Limoengreun päöl sinister",
  "block.minecraft.banner.stripe_right.magenta": "Magenta päöl sinister",
  "block.minecraft.banner.stripe_right.orange": "Oranje päöl sinister",
  "block.minecraft.banner.stripe_right.pink": "Roze päöl sinister",
  "block.minecraft.banner.stripe_right.purple": "Paarse päöl sinister",
  "block.minecraft.banner.stripe_right.red": "Roede päöl sinister",
  "block.minecraft.banner.stripe_right.white": "Witte päöl sinister",
  "block.minecraft.banner.stripe_right.yellow": "Gaele päöl sinister",
  "block.minecraft.banner.stripe_top.black": "Zjwarte top",
  "block.minecraft.banner.stripe_top.blue": "Blauwe top",
  "block.minecraft.banner.stripe_top.brown": "Broene top",
  "block.minecraft.banner.stripe_top.cyan": "Turquoise top",
  "block.minecraft.banner.stripe_top.gray": "Grieze top",
  "block.minecraft.banner.stripe_top.green": "Greune top",
  "block.minecraft.banner.stripe_top.light_blue": "Leechtblauwe top",
  "block.minecraft.banner.stripe_top.light_gray": "Leechtgrieze top",
  "block.minecraft.banner.stripe_top.lime": "Limoengreun top",
  "block.minecraft.banner.stripe_top.magenta": "Magenta top",
  "block.minecraft.banner.stripe_top.orange": "Oranje top",
  "block.minecraft.banner.stripe_top.pink": "Roze top",
  "block.minecraft.banner.stripe_top.purple": "Paarse top",
  "block.minecraft.banner.stripe_top.red": "Roeje top",
  "block.minecraft.banner.stripe_top.white": "Witte top",
  "block.minecraft.banner.stripe_top.yellow": "Gaele top",
  "block.minecraft.banner.triangle_bottom.black": "Zjwarte keper",
  "block.minecraft.banner.triangle_bottom.blue": "Blauwe keper",
  "block.minecraft.banner.triangle_bottom.brown": "Broene keper",
  "block.minecraft.banner.triangle_bottom.cyan": "Turquoise keper",
  "block.minecraft.banner.triangle_bottom.gray": "Grieze keper",
  "block.minecraft.banner.triangle_bottom.green": "Greune keper",
  "block.minecraft.banner.triangle_bottom.light_blue": "Leechtblauwe keper",
  "block.minecraft.banner.triangle_bottom.light_gray": "Leechtgrieze keper",
  "block.minecraft.banner.triangle_bottom.lime": "Limoengreune keper",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta keper",
  "block.minecraft.banner.triangle_bottom.orange": "Oranje keper",
  "block.minecraft.banner.triangle_bottom.pink": "Roze keper",
  "block.minecraft.banner.triangle_bottom.purple": "Paarse keper",
  "block.minecraft.banner.triangle_bottom.red": "Roede keper",
  "block.minecraft.banner.triangle_bottom.white": "Witte keper",
  "block.minecraft.banner.triangle_bottom.yellow": "Gaele keper",
  "block.minecraft.banner.triangle_top.black": "Zjwarte omgekeerde keper",
  "block.minecraft.banner.triangle_top.blue": "Blauwe omgekeerde keper",
  "block.minecraft.banner.triangle_top.brown": "Broene omgekeerde keper",
  "block.minecraft.banner.triangle_top.cyan": "Turquoise omgekeerde keper",
  "block.minecraft.banner.triangle_top.gray": "Grieze omgekeerde keper",
  "block.minecraft.banner.triangle_top.green": "Greune omgekeerde keper",
  "block.minecraft.banner.triangle_top.light_blue": "Leechtblauwe omgekeerde keper",
  "block.minecraft.banner.triangle_top.light_gray": "Leechtgrieze omgekeerde keper",
  "block.minecraft.banner.triangle_top.lime": "Limoengreune omgekierde keper",
  "block.minecraft.banner.triangle_top.magenta": "Magenta omgekeerde keper",
  "block.minecraft.banner.triangle_top.orange": "Oranje omgekeerde keper",
  "block.minecraft.banner.triangle_top.pink": "Roze omgekeerde keper",
  "block.minecraft.banner.triangle_top.purple": "Paarse omgekeerde keper",
  "block.minecraft.banner.triangle_top.red": "Roede omgekeerde keper",
  "block.minecraft.banner.triangle_top.white": "Witte omgekeerde keper",
  "block.minecraft.banner.triangle_top.yellow": "Gaele omgekeerde keper",
  "block.minecraft.banner.triangles_bottom.black": "Zjwarte ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.blue": "Blauwe ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.brown": "Broene ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.cyan": "Turquoise ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.gray": "Grieze ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.green": "Greune ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.light_blue": "Leechtblauwe ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.light_gray": "Leechtgrieze ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.lime": "Limoengreune ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.orange": "Oranje ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.pink": "Roze ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.purple": "Paarse ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.red": "Roede ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.white": "Witte ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.yellow": "Gaele ingesprongen basis",
  "block.minecraft.banner.triangles_top.black": "Zjwart ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.blue": "Blauw ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.brown": "Broen ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.cyan": "Turquoise ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.gray": "Gries ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.green": "Greun ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.light_blue": "Leechtblauw ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.light_gray": "Leechtgries ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.lime": "Limoengreun ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.magenta": "Magenta ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.orange": "Oranje ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.pink": "Roze ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.purple": "Paars ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.red": "Roed ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.white": "Wit ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.yellow": "Gael ingesprongen hoofd",
  "block.minecraft.barrel": "Vaat",
  "block.minecraft.barrier": "Barrière",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Bake",
  "block.minecraft.beacon.primary": "Primaire kracht",
  "block.minecraft.beacon.secondary": "Secundaire kracht",
  "block.minecraft.bed.no_sleep": "De kins allein tiedens de nach en tiedens onweer slaope",
  "block.minecraft.bed.not_safe": "De kéns noe neet slaopen; er zien monsters in de buurt",
  "block.minecraft.bed.obstructed": "Dit bèd is belemmerd",
  "block.minecraft.bed.occupied": "Dit bèd is bezat",
  "block.minecraft.bed.too_far_away": "De kéns noe neet slaopen; het bed is te ver weg",
  "block.minecraft.bedrock": "Fondsjtein",
  "block.minecraft.bee_nest": "Biejenest",
  "block.minecraft.beehive": "Biejekorf",
  "block.minecraft.beetroots": "Bieten",
  "block.minecraft.bell": "Bel",
  "block.minecraft.big_dripleaf": "Groette druppelblaad",
  "block.minecraft.big_dripleaf_stem": "Groette druppelblaadstengel",
  "block.minecraft.birch_button": "Berke Knop",
  "block.minecraft.birch_door": "Birkehoute duuer",
  "block.minecraft.birch_fence": "Berkenhouten hek",
  "block.minecraft.birch_fence_gate": "Berkenhouten peurtje",
  "block.minecraft.birch_hanging_sign": "Berkenhouten hangbord",
  "block.minecraft.birch_leaves": "Bérkenblajere",
  "block.minecraft.birch_log": "Berkenstjam",
  "block.minecraft.birch_planks": "Berkenhouten plenk",
  "block.minecraft.birch_pressure_plate": "Berkehoute Drukplaat",
  "block.minecraft.birch_sapling": "Berkenkiemplant",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Berkenhouten bord",
  "block.minecraft.birch_slab": "Berkenhouten plaat",
  "block.minecraft.birch_stairs": "Berkehoute traeje",
  "block.minecraft.birch_trapdoor": "Berkehouten valloek",
  "block.minecraft.birch_wall_hanging_sign": "Berkenhouten oethangbord",
  "block.minecraft.birch_wall_sign": "Berkenhouten bord aon moor",
  "block.minecraft.birch_wood": "Birkehout",
  "block.minecraft.black_banner": "Zjwarte banier",
  "block.minecraft.black_bed": "Zjwart bèd",
  "block.minecraft.black_candle": "Zwarte kaars",
  "block.minecraft.black_candle_cake": "Taart met zwarte kaars",
  "block.minecraft.black_carpet": "Zjwart Kerpèt",
  "block.minecraft.black_concrete": "Zjwart beton",
  "block.minecraft.black_concrete_powder": "Zjwart cement",
  "block.minecraft.black_glazed_terracotta": "Zjwartgeglazuurde terracotta",
  "block.minecraft.black_shulker_box": "Zjwarte Shulkerdoeas",
  "block.minecraft.black_stained_glass": "Zjwart gekleurd glaas",
  "block.minecraft.black_stained_glass_pane": "Zjwart gekleurde glazen roet",
  "block.minecraft.black_terracotta": "Zjwarte Terracotta",
  "block.minecraft.black_wool": "Zjwarte wol",
  "block.minecraft.blackstone": "Zwartstein",
  "block.minecraft.blackstone_slab": "Zwartstein plaat",
  "block.minecraft.blackstone_stairs": "Zwartstein traeje",
  "block.minecraft.blackstone_wall": "Zwartstein moor",
  "block.minecraft.blast_furnace": "Hoegaove",
  "block.minecraft.blue_banner": "Blauwe banier",
  "block.minecraft.blue_bed": "Blauw bèd",
  "block.minecraft.blue_candle": "Blauwe kaars",
  "block.minecraft.blue_candle_cake": "Taart met blauwe kaars",
  "block.minecraft.blue_carpet": "Blauw Kerpèt",
  "block.minecraft.blue_concrete": "Blauw beton",
  "block.minecraft.blue_concrete_powder": "Blauw cement",
  "block.minecraft.blue_glazed_terracotta": "Blauwgeglazuurde terracotta",
  "block.minecraft.blue_ice": "Blauw ies",
  "block.minecraft.blue_orchid": "Blauwe orchidee",
  "block.minecraft.blue_shulker_box": "Blauwe Shulkerdoeas",
  "block.minecraft.blue_stained_glass": "Blauw gekleurd glaas",
  "block.minecraft.blue_stained_glass_pane": "Blauw gekleurde glazen roet",
  "block.minecraft.blue_terracotta": "Blauwe Terracotta",
  "block.minecraft.blue_wool": "Blauwe wol",
  "block.minecraft.bone_block": "Bottenblok",
  "block.minecraft.bookshelf": "Bokekas",
  "block.minecraft.brain_coral": "Hersenkoraal",
  "block.minecraft.brain_coral_block": "Hersenkoraalblok",
  "block.minecraft.brain_coral_fan": "Hersenkoraalwaaijer",
  "block.minecraft.brain_coral_wall_fan": "Hersenkoraalwaaier aon moer",
  "block.minecraft.brewing_stand": "Brouwstanderd",
  "block.minecraft.brick_slab": "Bakstein plaat",
  "block.minecraft.brick_stairs": "Bakstein traeje",
  "block.minecraft.brick_wall": "Baksteinen moor",
  "block.minecraft.bricks": "Baksteinen",
  "block.minecraft.brown_banner": "Broene banier",
  "block.minecraft.brown_bed": "Broen bèd",
  "block.minecraft.brown_candle": "Broene kaars",
  "block.minecraft.brown_candle_cake": "Taart met broene kaars",
  "block.minecraft.brown_carpet": "Broen Kerpèt",
  "block.minecraft.brown_concrete": "Broen beton",
  "block.minecraft.brown_concrete_powder": "Broen cement",
  "block.minecraft.brown_glazed_terracotta": "Broengeglazuurde terracotta",
  "block.minecraft.brown_mushroom": "Broene paddenstoel",
  "block.minecraft.brown_mushroom_block": "Broen paddenstoelenblok",
  "block.minecraft.brown_shulker_box": "Broene Shulkerdoeas",
  "block.minecraft.brown_stained_glass": "Broen gekleurd glaas",
  "block.minecraft.brown_stained_glass_pane": "Broen gekleurde glazen roet",
  "block.minecraft.brown_terracotta": "Broene Terracotta",
  "block.minecraft.brown_wool": "Broene wol",
  "block.minecraft.bubble_column": "Bellekolom",
  "block.minecraft.bubble_coral": "Blaaskoraal",
  "block.minecraft.bubble_coral_block": "Blaaskoraalblok",
  "block.minecraft.bubble_coral_fan": "Blaaskoraalwaaijer",
  "block.minecraft.bubble_coral_wall_fan": "Blaaskoraalwaaier aon moer",
  "block.minecraft.budding_amethyst": "Ontloekende amethist",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Vlaai",
  "block.minecraft.calcite": "Calciet",
  "block.minecraft.calibrated_sculk_sensor": "Gekalibreerde sculksensor",
  "block.minecraft.campfire": "Kampvuur",
  "block.minecraft.candle": "Kaars",
  "block.minecraft.candle_cake": "Taart met kaars",
  "block.minecraft.carrots": "Wortels",
  "block.minecraft.cartography_table": "Kartografietaofel",
  "block.minecraft.carved_pumpkin": "Gesjneeje pompoen",
  "block.minecraft.cauldron": "Kaetel",
  "block.minecraft.cave_air": "Grot loch",
  "block.minecraft.cave_vines": "Grot lianen",
  "block.minecraft.cave_vines_plant": "Grot liaanplant",
  "block.minecraft.chain": "Ketting",
  "block.minecraft.chain_command_block": "Gekoppeld opdrachblok",
  "block.minecraft.cherry_button": "Kesehouten knop",
  "block.minecraft.cherry_door": "Kesehouten duuer",
  "block.minecraft.cherry_fence": "Kesehouten hek",
  "block.minecraft.cherry_fence_gate": "Kesehouten peurtje",
  "block.minecraft.cherry_hanging_sign": "Kesehouten hangbord",
  "block.minecraft.cherry_leaves": "Keseblajere",
  "block.minecraft.cherry_log": "Keseboumstam",
  "block.minecraft.cherry_planks": "Kesehouten plenk",
  "block.minecraft.cherry_pressure_plate": "Kesehouten drukplaat",
  "block.minecraft.cherry_sapling": "Kesekiemplant",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Kesehouten bord",
  "block.minecraft.cherry_slab": "Kesehouten plaat",
  "block.minecraft.cherry_stairs": "Kesehouten traeje",
  "block.minecraft.cherry_trapdoor": "Kesehouten valloek",
  "block.minecraft.cherry_wall_hanging_sign": "Kesehouten oethangbord",
  "block.minecraft.cherry_wall_sign": "Kesehouten bord aon moor",
  "block.minecraft.cherry_wood": "Kesehout",
  "block.minecraft.chest": "Kis",
  "block.minecraft.chipped_anvil": "Gebarsjte aambild",
  "block.minecraft.chiseled_bookshelf": "Bewerkte bokekas",
  "block.minecraft.chiseled_copper": "Chiseled Copper",
  "block.minecraft.chiseled_deepslate": "Gebieteld deepleistein",
  "block.minecraft.chiseled_nether_bricks": "Gebietelde netherbakstein",
  "block.minecraft.chiseled_polished_blackstone": "Gebietelde gepolieste zwartstein",
  "block.minecraft.chiseled_quartz_block": "Gebieteld kwartsblok",
  "block.minecraft.chiseled_red_sandstone": "Gebietelde roeje zandstein",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Gebietelde zandstein",
  "block.minecraft.chiseled_stone_bricks": "Gebietelde bloksteinen",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "Chorusbloom",
  "block.minecraft.chorus_plant": "Chorusplant",
  "block.minecraft.clay": "Kleij",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Kaoleblok",
  "block.minecraft.coal_ore": "Sjteinkoolerts",
  "block.minecraft.coarse_dirt": "Grovve Drek",
  "block.minecraft.cobbled_deepslate": "Geplaveid deepleistein",
  "block.minecraft.cobbled_deepslate_slab": "Geplaveid deepleistein plaat",
  "block.minecraft.cobbled_deepslate_stairs": "Geplaveid deepleistein traeje",
  "block.minecraft.cobbled_deepslate_wall": "Geplaveid deepleistein môôr",
  "block.minecraft.cobblestone": "Keij",
  "block.minecraft.cobblestone_slab": "Keijplaat",
  "block.minecraft.cobblestone_stairs": "Keijstein traeje",
  "block.minecraft.cobblestone_wall": "Keijmoor",
  "block.minecraft.cobweb": "Spinneweb",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Opdrachblok",
  "block.minecraft.comparator": "Redstonevergelieker",
  "block.minecraft.composter": "Kómposbak",
  "block.minecraft.conduit": "Krach van oet de zee",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Kauperblok",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Kaupererts",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Korenbloom",
  "block.minecraft.cracked_deepslate_bricks": "Gebarsen deepleistein bakstein",
  "block.minecraft.cracked_deepslate_tiles": "Gebarsten deepleistein tégels",
  "block.minecraft.cracked_nether_bricks": "Gebarste Netherbakstein",
  "block.minecraft.cracked_polished_blackstone_bricks": "Gebarste gepolieste zwartstein bakstein",
  "block.minecraft.cracked_stone_bricks": "Gebarste bloksteinen",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Werkbank",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Creeperhoofd",
  "block.minecraft.creeper_wall_head": "Creeperhoofd aon moor",
  "block.minecraft.crimson_button": "Helroede houten knöp",
  "block.minecraft.crimson_door": "Helroede deur",
  "block.minecraft.crimson_fence": "Helroede houten hek",
  "block.minecraft.crimson_fence_gate": "Helroede houten peurtje",
  "block.minecraft.crimson_fungus": "Helroede zwam",
  "block.minecraft.crimson_hanging_sign": "Helroed houten hangbord",
  "block.minecraft.crimson_hyphae": "Helroede schimmeldraod",
  "block.minecraft.crimson_nylium": "Helroede nylium",
  "block.minecraft.crimson_planks": "Helroede houten plenk",
  "block.minecraft.crimson_pressure_plate": "Helroede houten drukplaat",
  "block.minecraft.crimson_roots": "Helroede wortelle",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Helroed houten bord",
  "block.minecraft.crimson_slab": "Helroede houten plaat",
  "block.minecraft.crimson_stairs": "Helroede houte traeje",
  "block.minecraft.crimson_stem": "Helroede stem",
  "block.minecraft.crimson_trapdoor": "Helroede houten valloek",
  "block.minecraft.crimson_wall_hanging_sign": "Helroed houten oethangbord",
  "block.minecraft.crimson_wall_sign": "Helroed bord aan moor",
  "block.minecraft.crying_obsidian": "Huilend obsidiaan",
  "block.minecraft.cut_copper": "Gesneeïen kauper",
  "block.minecraft.cut_copper_slab": "Gesneeïen kauper plaat",
  "block.minecraft.cut_copper_stairs": "Gesneeje kauper traeje",
  "block.minecraft.cut_red_sandstone": "Gesneeje roeie zandstein",
  "block.minecraft.cut_red_sandstone_slab": "Gesneeje roeje zandsteine plaat",
  "block.minecraft.cut_sandstone": "Gesneeje zandstein",
  "block.minecraft.cut_sandstone_slab": "Gesneeje zandsteine plaat",
  "block.minecraft.cyan_banner": "Turquoise banier",
  "block.minecraft.cyan_bed": "Turquoise bèd",
  "block.minecraft.cyan_candle": "Turquoise kaars",
  "block.minecraft.cyan_candle_cake": "Taart met turquoise kaars",
  "block.minecraft.cyan_carpet": "Turquoise Kerpèt",
  "block.minecraft.cyan_concrete": "Turquoise beton",
  "block.minecraft.cyan_concrete_powder": "Turquoise cement",
  "block.minecraft.cyan_glazed_terracotta": "Turquoisegeglazuurde terracotta",
  "block.minecraft.cyan_shulker_box": "Turquoise Shulkerdoeas",
  "block.minecraft.cyan_stained_glass": "Turquoise Gekleurde glaas",
  "block.minecraft.cyan_stained_glass_pane": "Turquoise Gekleurde glazen roet",
  "block.minecraft.cyan_terracotta": "Turqouoise terracotta",
  "block.minecraft.cyan_wool": "Turquoise Wol",
  "block.minecraft.damaged_anvil": "Beschadigd aambild",
  "block.minecraft.dandelion": "Paerdebloom",
  "block.minecraft.dark_oak_button": "Donkere Eikehoute Knop",
  "block.minecraft.dark_oak_door": "Dónkere eikenhouten duuer",
  "block.minecraft.dark_oak_fence": "Dónkere eikenhouten hek",
  "block.minecraft.dark_oak_fence_gate": "Donkere eikenhouten peurtje",
  "block.minecraft.dark_oak_hanging_sign": "Donkereikenhouten hangbord",
  "block.minecraft.dark_oak_leaves": "Dónkere eikenblajere",
  "block.minecraft.dark_oak_log": "Donkereeikenhoutensjtam",
  "block.minecraft.dark_oak_planks": "Donkereikenhouten plenk",
  "block.minecraft.dark_oak_pressure_plate": "Donkere Eikehoute Drukplaat",
  "block.minecraft.dark_oak_sapling": "Donkere eikenkiemplant",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Donkereikenhouten bord",
  "block.minecraft.dark_oak_slab": "Donkereeikenhouten plaat",
  "block.minecraft.dark_oak_stairs": "Donkereikenhoute traeje",
  "block.minecraft.dark_oak_trapdoor": "Donkereikenhouten valloek",
  "block.minecraft.dark_oak_wall_hanging_sign": "Donkereikenhouten oethangbord",
  "block.minecraft.dark_oak_wall_sign": "Donkereikenhouten bord aon moor",
  "block.minecraft.dark_oak_wood": "Donker Eikehout",
  "block.minecraft.dark_prismarine": "Donkerprismarien",
  "block.minecraft.dark_prismarine_slab": "Donkerprismarienplaat",
  "block.minecraft.dark_prismarine_stairs": "Donkerprismarien traeje",
  "block.minecraft.daylight_detector": "Daagleechsensor",
  "block.minecraft.dead_brain_coral": "Doed hersenkoraal",
  "block.minecraft.dead_brain_coral_block": "Doed hersenkoraalblok",
  "block.minecraft.dead_brain_coral_fan": "Doeje hersenkoraalwaaier",
  "block.minecraft.dead_brain_coral_wall_fan": "Doeje hersenkoraalwaaier aon moer",
  "block.minecraft.dead_bubble_coral": "Doed blaaskoraal",
  "block.minecraft.dead_bubble_coral_block": "Doed blaaskoraalblok",
  "block.minecraft.dead_bubble_coral_fan": "Doeje blaaskoraalwaaier",
  "block.minecraft.dead_bubble_coral_wall_fan": "Doeje blaaskoraalwaaier aon moer",
  "block.minecraft.dead_bush": "Doeje stroek",
  "block.minecraft.dead_fire_coral": "Doed brandkoraal",
  "block.minecraft.dead_fire_coral_block": "Doed brandkoraalblok",
  "block.minecraft.dead_fire_coral_fan": "Doeje brandkoraalwaaier",
  "block.minecraft.dead_fire_coral_wall_fan": "Doeje brandkoraalwaaier aon moer",
  "block.minecraft.dead_horn_coral": "Doed hoornkoraal",
  "block.minecraft.dead_horn_coral_block": "Doed haorekoraalblok",
  "block.minecraft.dead_horn_coral_fan": "Doeje hoornkoraalwaaier",
  "block.minecraft.dead_horn_coral_wall_fan": "Doeje hoornkoraalwaaier aon moer",
  "block.minecraft.dead_tube_coral": "Doed buiskoraal",
  "block.minecraft.dead_tube_coral_block": "Doed buuskoraalblok",
  "block.minecraft.dead_tube_coral_fan": "Doeje buiskoraalwaaier",
  "block.minecraft.dead_tube_coral_wall_fan": "Doeje buiskoraalwaaier aon moer",
  "block.minecraft.decorated_pot": "Versierde pot",
  "block.minecraft.deepslate": "Deepleistein",
  "block.minecraft.deepslate_brick_slab": "Deepleistein bakstein plaat",
  "block.minecraft.deepslate_brick_stairs": "Deepleistein bakstein traeje",
  "block.minecraft.deepslate_brick_wall": "Deepleistein bakstein môôr",
  "block.minecraft.deepslate_bricks": "Deepleistein bakstein",
  "block.minecraft.deepslate_coal_ore": "Deepkoolerts",
  "block.minecraft.deepslate_copper_ore": "Deepkaupererts",
  "block.minecraft.deepslate_diamond_ore": "Deepdiamanterts",
  "block.minecraft.deepslate_emerald_ore": "Deepsmaragderts",
  "block.minecraft.deepslate_gold_ore": "Deepgolderts",
  "block.minecraft.deepslate_iron_ore": "Deepiezererts",
  "block.minecraft.deepslate_lapis_ore": "Deeplapislazuli-erts",
  "block.minecraft.deepslate_redstone_ore": "Deepredstone-erts",
  "block.minecraft.deepslate_tile_slab": "Deepleistein tégel plaat",
  "block.minecraft.deepslate_tile_stairs": "Deepleistein tégeltraeje",
  "block.minecraft.deepslate_tile_wall": "Deepleistein tégel môôr",
  "block.minecraft.deepslate_tiles": "Deepleistein tégels",
  "block.minecraft.detector_rail": "Detectiespoear",
  "block.minecraft.diamond_block": "Diamantblok",
  "block.minecraft.diamond_ore": "Diamanterts",
  "block.minecraft.diorite": "Dioriet",
  "block.minecraft.diorite_slab": "Diorietplaat",
  "block.minecraft.diorite_stairs": "Dioriet traeje",
  "block.minecraft.diorite_wall": "Diorietmoer",
  "block.minecraft.dirt": "Drek",
  "block.minecraft.dirt_path": "Aardepaej",
  "block.minecraft.dispenser": "Dispenser",
  "block.minecraft.dragon_egg": "Drakenei",
  "block.minecraft.dragon_head": "Drakenhoofd",
  "block.minecraft.dragon_wall_head": "Drakenhoofd aon moer",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Gedraögde Kelp Blok",
  "block.minecraft.dripstone_block": "Druupsteinblok",
  "block.minecraft.dropper": "Dropper",
  "block.minecraft.emerald_block": "Smaragdblok",
  "block.minecraft.emerald_ore": "Smaragderts",
  "block.minecraft.enchanting_table": "Betouvertaofel",
  "block.minecraft.end_gateway": "Endtoegangsportaal",
  "block.minecraft.end_portal": "Endportaal",
  "block.minecraft.end_portal_frame": "Endportaalframe",
  "block.minecraft.end_rod": "Endstaaf",
  "block.minecraft.end_stone": "Endstein",
  "block.minecraft.end_stone_brick_slab": "Endbloksteinen plaat",
  "block.minecraft.end_stone_brick_stairs": "Endblokstein traeje",
  "block.minecraft.end_stone_brick_wall": "Endbakstein moor",
  "block.minecraft.end_stone_bricks": "Endbloksteinen",
  "block.minecraft.ender_chest": "Enderkis",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "Bloetgestelde kauper",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Bloetgestelde gesneeïen kauper",
  "block.minecraft.exposed_cut_copper_slab": "Bloetgestelde gesneeïen kauper plaat",
  "block.minecraft.exposed_cut_copper_stairs": "Bloetgestelde gesneeje kauper traeje",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Akkerlandj",
  "block.minecraft.fern": "Varen",
  "block.minecraft.fire": "Vuur",
  "block.minecraft.fire_coral": "Brandkoraal",
  "block.minecraft.fire_coral_block": "Brandkoraalblok",
  "block.minecraft.fire_coral_fan": "Brandkoraalwaaijer",
  "block.minecraft.fire_coral_wall_fan": "Brandkoraalwaaier aon moer",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Bevederingstaofel",
  "block.minecraft.flower_pot": "Bloompot",
  "block.minecraft.flowering_azalea": "Bleuijende azalea",
  "block.minecraft.flowering_azalea_leaves": "Bleuiende azaleablajer",
  "block.minecraft.frogspawn": "Kwakkerdril",
  "block.minecraft.frosted_ice": "Bevroren ies",
  "block.minecraft.furnace": "Aove",
  "block.minecraft.gilded_blackstone": "Vergulde zwartstein",
  "block.minecraft.glass": "Glaas",
  "block.minecraft.glass_pane": "Glazen Roet",
  "block.minecraft.glow_lichen": "Gloeiende korstmos",
  "block.minecraft.glowstone": "Gloeistein",
  "block.minecraft.gold_block": "Goudblok",
  "block.minecraft.gold_ore": "Gouderts",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Graniet",
  "block.minecraft.granite_slab": "Granietplaat",
  "block.minecraft.granite_stairs": "Graniet traeje",
  "block.minecraft.granite_wall": "Granietmoer",
  "block.minecraft.grass": "Graas",
  "block.minecraft.grass_block": "Graasblok",
  "block.minecraft.gravel": "Grind",
  "block.minecraft.gray_banner": "Grieze banier",
  "block.minecraft.gray_bed": "Gries bèd",
  "block.minecraft.gray_candle": "Grieze kaars",
  "block.minecraft.gray_candle_cake": "Taart met grieze kaars",
  "block.minecraft.gray_carpet": "Gries Kerpèt",
  "block.minecraft.gray_concrete": "Gries beton",
  "block.minecraft.gray_concrete_powder": "Gries cement",
  "block.minecraft.gray_glazed_terracotta": "Griesgeglazuurde terracotta",
  "block.minecraft.gray_shulker_box": "Grieze Shulkerdoeas",
  "block.minecraft.gray_stained_glass": "Gries gekleurd glaas",
  "block.minecraft.gray_stained_glass_pane": "Gries gekleurde glazen roet",
  "block.minecraft.gray_terracotta": "Griese Terracotta",
  "block.minecraft.gray_wool": "Grieze wol",
  "block.minecraft.green_banner": "Greune banier",
  "block.minecraft.green_bed": "Greun bèd",
  "block.minecraft.green_candle": "Greune kaars",
  "block.minecraft.green_candle_cake": "Taart met greune kaars",
  "block.minecraft.green_carpet": "Greun Kerpèt",
  "block.minecraft.green_concrete": "Greun beton",
  "block.minecraft.green_concrete_powder": "Greun cement",
  "block.minecraft.green_glazed_terracotta": "Greungeglazuurde terracotta",
  "block.minecraft.green_shulker_box": "Greune Shulkerdoeas",
  "block.minecraft.green_stained_glass": "Greun gekleurd glaas",
  "block.minecraft.green_stained_glass_pane": "Greun gekleurde glazen roet",
  "block.minecraft.green_terracotta": "Greune Terracotta",
  "block.minecraft.green_wool": "Greune wol",
  "block.minecraft.grindstone": "Sliepsjtein",
  "block.minecraft.hanging_roots": "Hangende wortelle",
  "block.minecraft.hay_block": " Huijbaal",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Zware drukgevoelige plaat",
  "block.minecraft.honey_block": "Höning Bluk",
  "block.minecraft.honeycomb_block": "Höningraat Bluk",
  "block.minecraft.hopper": "Trechter",
  "block.minecraft.horn_coral": "Haorekoraal",
  "block.minecraft.horn_coral_block": "Haorekoraalblok",
  "block.minecraft.horn_coral_fan": "Haorekoraalwaaijer",
  "block.minecraft.horn_coral_wall_fan": "Hoornkoraalwaaier aon moer",
  "block.minecraft.ice": "Ies",
  "block.minecraft.infested_chiseled_stone_bricks": "Geïnfecteerde gebietelde bloksteinen",
  "block.minecraft.infested_cobblestone": "Geïnfecteerde kiezelsjtein",
  "block.minecraft.infested_cracked_stone_bricks": "Geïnfecteerde gebarste bloksteinen",
  "block.minecraft.infested_deepslate": "Geïnfesteerde deepleistein",
  "block.minecraft.infested_mossy_stone_bricks": "Geïnfecteerde mossige bloksteinen",
  "block.minecraft.infested_stone": "Geïnfecteerde sjtein",
  "block.minecraft.infested_stone_bricks": "Geïnfecteerde bloksteinen",
  "block.minecraft.iron_bars": "Iezer Stave",
  "block.minecraft.iron_block": "Iezerblok",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Iezere Deur",
  "block.minecraft.iron_ore": "Iezererts",
  "block.minecraft.iron_trapdoor": "Iezer valloek",
  "block.minecraft.jack_o_lantern": "Jack-o'-lantern",
  "block.minecraft.jigsaw": "Puzzelblok",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Oerwoud Knop",
  "block.minecraft.jungle_door": "Oerwoudhouten duuer",
  "block.minecraft.jungle_fence": "Oerwoudhouten hek",
  "block.minecraft.jungle_fence_gate": "Oerwoudhouten peurtje",
  "block.minecraft.jungle_hanging_sign": "Oerwoudhouten hangbord",
  "block.minecraft.jungle_leaves": "Oerwoudblajere",
  "block.minecraft.jungle_log": "Oerwoudstam",
  "block.minecraft.jungle_planks": "Oerwoudhouten plenk",
  "block.minecraft.jungle_pressure_plate": "Oerwoudhoute Drukplaat",
  "block.minecraft.jungle_sapling": "Oerwoudkiemplant",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Oerwoudhouten bord",
  "block.minecraft.jungle_slab": "Oerwoudhouten plaat",
  "block.minecraft.jungle_stairs": "Oerwoudhoute traeje",
  "block.minecraft.jungle_trapdoor": "Oerwoudhouten valloek",
  "block.minecraft.jungle_wall_hanging_sign": "Oerwoudhouten oethangbord",
  "block.minecraft.jungle_wall_sign": "Oerwoudhouten bord aon moor",
  "block.minecraft.jungle_wood": "Oerwoudhout",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelpplant",
  "block.minecraft.ladder": "Lèdder",
  "block.minecraft.lantern": "Lantaer",
  "block.minecraft.lapis_block": "Lapislazuliblok",
  "block.minecraft.lapis_ore": "Lapis lazuli-erts",
  "block.minecraft.large_amethyst_bud": "Groete amethistknöp",
  "block.minecraft.large_fern": "Groete varen",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lava Kaetel",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Lessenear",
  "block.minecraft.lever": "Hendel",
  "block.minecraft.light": "Leecht",
  "block.minecraft.light_blue_banner": "Leechtblauwe banier",
  "block.minecraft.light_blue_bed": "Leechtblauw bèd",
  "block.minecraft.light_blue_candle": "Lichtblauwe kaars",
  "block.minecraft.light_blue_candle_cake": "Taart met licht blauwe kaars",
  "block.minecraft.light_blue_carpet": "Leechblauw tapiet",
  "block.minecraft.light_blue_concrete": "Leechtblauw beton",
  "block.minecraft.light_blue_concrete_powder": "Leechtblauw cement",
  "block.minecraft.light_blue_glazed_terracotta": "Leechtblauwgeglazuurde terracotta",
  "block.minecraft.light_blue_shulker_box": "Leechblauwe Shulkerdoeas",
  "block.minecraft.light_blue_stained_glass": "Leechtblauwgekleurd glaas",
  "block.minecraft.light_blue_stained_glass_pane": "Leechtblauwgekleurde glazen roet",
  "block.minecraft.light_blue_terracotta": "Leechtblauwe terracotta",
  "block.minecraft.light_blue_wool": "Leechtblauwe wol",
  "block.minecraft.light_gray_banner": "Leechtgrieze banier",
  "block.minecraft.light_gray_bed": "Leechtgries bèd",
  "block.minecraft.light_gray_candle": "Lichtgrieze kaars",
  "block.minecraft.light_gray_candle_cake": "Taart met licht grieze kaars",
  "block.minecraft.light_gray_carpet": "Leechgries tapiet",
  "block.minecraft.light_gray_concrete": "Leechtgries beton",
  "block.minecraft.light_gray_concrete_powder": "Leechtgries cement",
  "block.minecraft.light_gray_glazed_terracotta": "Leechtgriesgeglazuurde terracotta",
  "block.minecraft.light_gray_shulker_box": "Leechtgrieze Shulkerdoeas",
  "block.minecraft.light_gray_stained_glass": "Leechtgriesgekleurd glaas",
  "block.minecraft.light_gray_stained_glass_pane": "Leechtgriesgekleurde glazen roet",
  "block.minecraft.light_gray_terracotta": "Leechtgrieze terracotta",
  "block.minecraft.light_gray_wool": "Leechtgrieze wol",
  "block.minecraft.light_weighted_pressure_plate": "Lichte drukgeveulige plaat",
  "block.minecraft.lightning_rod": "Bliksem aafleijer",
  "block.minecraft.lilac": "Sering",
  "block.minecraft.lily_of_the_valley": "Lelietje-van-dalen",
  "block.minecraft.lily_pad": "Waterlelie",
  "block.minecraft.lime_banner": "Limoengreune banier",
  "block.minecraft.lime_bed": "Limoengreun bèd",
  "block.minecraft.lime_candle": "Limoengreune kaars",
  "block.minecraft.lime_candle_cake": "Taart met limoengreune kaars",
  "block.minecraft.lime_carpet": "Limoengreun tapiet",
  "block.minecraft.lime_concrete": "Limoengreun beton",
  "block.minecraft.lime_concrete_powder": "Limoengreun cement",
  "block.minecraft.lime_glazed_terracotta": "Limoengreungeglazuurde terracotta",
  "block.minecraft.lime_shulker_box": "Limoengreune Shulkerdoes",
  "block.minecraft.lime_stained_glass": "Limoengreungekleurd glaas",
  "block.minecraft.lime_stained_glass_pane": "Limoengreungekleurde glazen roet",
  "block.minecraft.lime_terracotta": "Limoengreune terracotta",
  "block.minecraft.lime_wool": "Limoengreune wol",
  "block.minecraft.lodestone": "Zeilstein",
  "block.minecraft.loom": "Weefgetouw",
  "block.minecraft.magenta_banner": "Magenta banier",
  "block.minecraft.magenta_bed": "Magenta bèd",
  "block.minecraft.magenta_candle": "Magenta kaars",
  "block.minecraft.magenta_candle_cake": "Taart met magenta kaars",
  "block.minecraft.magenta_carpet": "Magenta Kerpèt",
  "block.minecraft.magenta_concrete": "Magenta beton",
  "block.minecraft.magenta_concrete_powder": "Magenta cement",
  "block.minecraft.magenta_glazed_terracotta": "Magentageglazuurde terracotta",
  "block.minecraft.magenta_shulker_box": "Magenta Shulkerdoeas",
  "block.minecraft.magenta_stained_glass": "Magenta gekleurd glaas",
  "block.minecraft.magenta_stained_glass_pane": "Magenta gekleurde glazen roet",
  "block.minecraft.magenta_terracotta": "Magenta terracotta",
  "block.minecraft.magenta_wool": "Magenta wol",
  "block.minecraft.magma_block": "Magmablok",
  "block.minecraft.mangrove_button": "Mangrovehouten knop",
  "block.minecraft.mangrove_door": "Mangrovehouten duuer",
  "block.minecraft.mangrove_fence": "Mangrovehouten hek",
  "block.minecraft.mangrove_fence_gate": "Mangrovehouten peurtje",
  "block.minecraft.mangrove_hanging_sign": "Mangrovehouten hangbord",
  "block.minecraft.mangrove_leaves": "Mangroveblajere",
  "block.minecraft.mangrove_log": "Mangrovestam",
  "block.minecraft.mangrove_planks": "Mangrovehouten plenk",
  "block.minecraft.mangrove_pressure_plate": "Mangrovehouten drukplaat",
  "block.minecraft.mangrove_propagule": "Mangrovebreujknop",
  "block.minecraft.mangrove_roots": "Mangrovewortelle",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Mangrovehouten bord",
  "block.minecraft.mangrove_slab": "Mangrovehouten plaat",
  "block.minecraft.mangrove_stairs": "Mangrovehouten traeje",
  "block.minecraft.mangrove_trapdoor": "Mangrovehouten valloek",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovehouten oethangbord",
  "block.minecraft.mangrove_wall_sign": "Mangrovehouten bord aon moor",
  "block.minecraft.mangrove_wood": "Mangrovehout",
  "block.minecraft.medium_amethyst_bud": "Middelgroete amethistknöp",
  "block.minecraft.melon": "Meloen",
  "block.minecraft.melon_stem": "Meloen sjtam",
  "block.minecraft.moss_block": "Mosblok",
  "block.minecraft.moss_carpet": "Mostapiét",
  "block.minecraft.mossy_cobblestone": "Mossige keijstein",
  "block.minecraft.mossy_cobblestone_slab": "Mossige keisjteinen plaat",
  "block.minecraft.mossy_cobblestone_stairs": "Mossige keistein traeje",
  "block.minecraft.mossy_cobblestone_wall": "Mossige keijmoor",
  "block.minecraft.mossy_stone_brick_slab": "Mossige bloksteinen plaat",
  "block.minecraft.mossy_stone_brick_stairs": "Mossige blokstein traeje",
  "block.minecraft.mossy_stone_brick_wall": "Mossige bloksteinen moor",
  "block.minecraft.mossy_stone_bricks": "Mossige bloksteinen",
  "block.minecraft.moving_piston": "Bewaegende zuiger",
  "block.minecraft.mud": "Drek",
  "block.minecraft.mud_brick_slab": "Dreksteinen plaat",
  "block.minecraft.mud_brick_stairs": "Moddersteinen traeje",
  "block.minecraft.mud_brick_wall": "Dreksteinen moor",
  "block.minecraft.mud_bricks": "Dreksteinen",
  "block.minecraft.muddy_mangrove_roots": "Modderige mangrovewortelle",
  "block.minecraft.mushroom_stem": "Paddenstoelensjtam",
  "block.minecraft.mycelium": "Zwamvlok",
  "block.minecraft.nether_brick_fence": "Netherbaksteinen hek",
  "block.minecraft.nether_brick_slab": "Netherbakstein plaat",
  "block.minecraft.nether_brick_stairs": "Netherbakstein traeje",
  "block.minecraft.nether_brick_wall": "Netherbakstein moor",
  "block.minecraft.nether_bricks": "Netherbakstein",
  "block.minecraft.nether_gold_ore": "Nethergolderts",
  "block.minecraft.nether_portal": "Netherportaal",
  "block.minecraft.nether_quartz_ore": "Netherkwartserts",
  "block.minecraft.nether_sprouts": "Netherscheut'n",
  "block.minecraft.nether_wart": "Netherkroed",
  "block.minecraft.nether_wart_block": "Netherkroedblok",
  "block.minecraft.netherite_block": "Netherietblok",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nootblok",
  "block.minecraft.oak_button": "Eike Knop",
  "block.minecraft.oak_door": "Eike duuer",
  "block.minecraft.oak_fence": "Eikenhouten hek",
  "block.minecraft.oak_fence_gate": "Eikenhouten peurtje",
  "block.minecraft.oak_hanging_sign": "Eikenhouten hangbord",
  "block.minecraft.oak_leaves": "Eikenblajere",
  "block.minecraft.oak_log": "Eikenstjam",
  "block.minecraft.oak_planks": "Eikenhouten plenk",
  "block.minecraft.oak_pressure_plate": "Eikehoute Drukplaat",
  "block.minecraft.oak_sapling": "Eikenkiemplant",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Eikenhouten bord",
  "block.minecraft.oak_slab": "Eikenhouten plaat",
  "block.minecraft.oak_stairs": "Eikehoute traeje",
  "block.minecraft.oak_trapdoor": "Eikhouten valloek",
  "block.minecraft.oak_wall_hanging_sign": "Eikenhouten oethangbord",
  "block.minecraft.oak_wall_sign": "Eikenhouten bord aon moor",
  "block.minecraft.oak_wood": "Eikehout",
  "block.minecraft.observer": "Observeerder",
  "block.minecraft.obsidian": "Obsidiaan",
  "block.minecraft.ochre_froglight": "Okergael kwakkerleecht",
  "block.minecraft.ominous_banner": "Dreigende Banner",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Oranje banier",
  "block.minecraft.orange_bed": "Oranje bèd",
  "block.minecraft.orange_candle": "Oranje kaars",
  "block.minecraft.orange_candle_cake": "Taart met oranje kaars",
  "block.minecraft.orange_carpet": "Oranje Kerpèt",
  "block.minecraft.orange_concrete": "Oranje beton",
  "block.minecraft.orange_concrete_powder": "Oranje cement",
  "block.minecraft.orange_glazed_terracotta": "Oranjegeglazuurde terracotta",
  "block.minecraft.orange_shulker_box": "Oranje Shulkerdoeas",
  "block.minecraft.orange_stained_glass": "Oranje gekleurd glaas",
  "block.minecraft.orange_stained_glass_pane": "Oranjegekleurde glazen roet",
  "block.minecraft.orange_terracotta": "Oranje Terracotta",
  "block.minecraft.orange_tulip": "Oranje tulp",
  "block.minecraft.orange_wool": "Oranje wol",
  "block.minecraft.oxeye_daisy": "Margriet",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "Geoxideerd kauper",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Geoxideerd gesneeïen kauper",
  "block.minecraft.oxidized_cut_copper_slab": "Geoxideerd gesneeïen kauper plaat",
  "block.minecraft.oxidized_cut_copper_stairs": "Geoxideerde gesneeje kauper traeje",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Pakies",
  "block.minecraft.packed_mud": "Pakdrek",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "Paars kwakkerleecht",
  "block.minecraft.peony": "Pioenroeas",
  "block.minecraft.petrified_oak_slab": "Verstjeende eikenhouten plaat",
  "block.minecraft.piglin_head": "Piglinhoofd",
  "block.minecraft.piglin_wall_head": "Piglinhoofd aon moer",
  "block.minecraft.pink_banner": "Roze banier",
  "block.minecraft.pink_bed": "Roze bèd",
  "block.minecraft.pink_candle": "Roze kaars",
  "block.minecraft.pink_candle_cake": "Taart met roze kaars",
  "block.minecraft.pink_carpet": "Roze Kerpèt",
  "block.minecraft.pink_concrete": "Roze beton",
  "block.minecraft.pink_concrete_powder": "Roze cement",
  "block.minecraft.pink_glazed_terracotta": "Rozegeglazuurde terracotta",
  "block.minecraft.pink_petals": "Roze bleumblajere",
  "block.minecraft.pink_shulker_box": "Roze Shulkerdoeas",
  "block.minecraft.pink_stained_glass": "Roze gekleurd glaas",
  "block.minecraft.pink_stained_glass_pane": "Roze gekleurde glazen roet",
  "block.minecraft.pink_terracotta": "Roze Terracotta",
  "block.minecraft.pink_tulip": "Roze tulp",
  "block.minecraft.pink_wool": "Roze wol",
  "block.minecraft.piston": "Zuiger",
  "block.minecraft.piston_head": "Zuiger kop",
  "block.minecraft.pitcher_crop": "Baekerplantgewas",
  "block.minecraft.pitcher_plant": "Baekerplant",
  "block.minecraft.player_head": "Sjpeler Kop",
  "block.minecraft.player_head.named": "%s's Hoofd",
  "block.minecraft.player_wall_head": "Sjpelerhoofd aon moer",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Puntige druupstein",
  "block.minecraft.polished_andesite": "Gepolijste Andesiet",
  "block.minecraft.polished_andesite_slab": "Gepolieste andesietplaat",
  "block.minecraft.polished_andesite_stairs": "Gepolieste andesiet traeje",
  "block.minecraft.polished_basalt": "Gepolieste basalt",
  "block.minecraft.polished_blackstone": "Gepolieste zwartstein",
  "block.minecraft.polished_blackstone_brick_slab": "Gepolieste zwartstein bakstein plaat",
  "block.minecraft.polished_blackstone_brick_stairs": "Gepolieste zwartstein bakstein traeje",
  "block.minecraft.polished_blackstone_brick_wall": "Gepolieste zwartstein bakstein moor",
  "block.minecraft.polished_blackstone_bricks": "Gepolieste zwartstein bakstein",
  "block.minecraft.polished_blackstone_button": "Gepolieste zwartstein knöp",
  "block.minecraft.polished_blackstone_pressure_plate": "Gepolieste zwartstein drukplaat",
  "block.minecraft.polished_blackstone_slab": "Gepolieste zwartstein plaat",
  "block.minecraft.polished_blackstone_stairs": "Gepolieste zwartstein traeje",
  "block.minecraft.polished_blackstone_wall": "Gepolieste zwartstein moor",
  "block.minecraft.polished_deepslate": "Gepoliest deepleistein",
  "block.minecraft.polished_deepslate_slab": "Gepoliest deepleistein plaat",
  "block.minecraft.polished_deepslate_stairs": "Gepolieste deepleistein traeje",
  "block.minecraft.polished_deepslate_wall": "Gepoliest deepleistein môôr",
  "block.minecraft.polished_diorite": "Gepolijste Dioriet",
  "block.minecraft.polished_diorite_slab": "Gepolieste diorietplaat",
  "block.minecraft.polished_diorite_stairs": "Gepolieste dioriet traeje",
  "block.minecraft.polished_granite": "Gepolijste Graniet",
  "block.minecraft.polished_granite_slab": "Gepolieste granietplaat",
  "block.minecraft.polished_granite_stairs": "Gepolieste graniet traeje",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Klaproeas",
  "block.minecraft.potatoes": "Aerpel",
  "block.minecraft.potted_acacia_sapling": "Opgepotte acaciakiemplant",
  "block.minecraft.potted_allium": "Opgepot look",
  "block.minecraft.potted_azalea_bush": "Opgepotte azalea",
  "block.minecraft.potted_azure_bluet": "Opgepot porseleinsjterke",
  "block.minecraft.potted_bamboo": "Opgepotte bamboe",
  "block.minecraft.potted_birch_sapling": "Opgepotte berkenkiemplant",
  "block.minecraft.potted_blue_orchid": "Opgepotte blauwe orchidee",
  "block.minecraft.potted_brown_mushroom": "Opgepotte broene paddenstoel",
  "block.minecraft.potted_cactus": "Opgepotte kaktus",
  "block.minecraft.potted_cherry_sapling": "Opgepotte kesekiemplant",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Opgepotte korenbloom",
  "block.minecraft.potted_crimson_fungus": "Opgepotte helroede zwam",
  "block.minecraft.potted_crimson_roots": "Opgepotte helroede wortelle",
  "block.minecraft.potted_dandelion": "Opgepotte paerdenbloem",
  "block.minecraft.potted_dark_oak_sapling": "Opgepotte donkereikenkiemplant",
  "block.minecraft.potted_dead_bush": "Opgepotte doeje sjtroek",
  "block.minecraft.potted_fern": "Opgepotte varen",
  "block.minecraft.potted_flowering_azalea_bush": "Opgepotte bleuiende azalea",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Opgepotte oerwoudkiemplant",
  "block.minecraft.potted_lily_of_the_valley": "Opgepot lelietje-van-dalen",
  "block.minecraft.potted_mangrove_propagule": "Opgepotte mangrovebreujknop",
  "block.minecraft.potted_oak_sapling": "Opgepotte eikenkiemplant",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Opgepotte oranje tulp",
  "block.minecraft.potted_oxeye_daisy": "Opgepotte margriet",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Opgepotte roze tulp",
  "block.minecraft.potted_poppy": "Opgepotte klaproos",
  "block.minecraft.potted_red_mushroom": "Opgepotte roeje paddenstoel",
  "block.minecraft.potted_red_tulip": "Opgepotte roeje tulp",
  "block.minecraft.potted_spruce_sapling": "Opgepotte sparrenkiemplant",
  "block.minecraft.potted_torchflower": "Opgepotte fakkelbloom",
  "block.minecraft.potted_warped_fungus": "Opgepotte spoekachtige zwam",
  "block.minecraft.potted_warped_roots": "Opgepotte spoekachtige wortelle",
  "block.minecraft.potted_white_tulip": "Opgepotte witte tulp",
  "block.minecraft.potted_wither_rose": "Opgepotte Witherroes",
  "block.minecraft.powder_snow": "Poeijersjnie",
  "block.minecraft.powder_snow_cauldron": "Poeijersjnie Kaetel",
  "block.minecraft.powered_rail": "Aandrijfspoear",
  "block.minecraft.prismarine": "Prismarien",
  "block.minecraft.prismarine_brick_slab": "Prismarienbakstein plaat",
  "block.minecraft.prismarine_brick_stairs": "Prismarienbakstein traeje",
  "block.minecraft.prismarine_bricks": "Prismarienbakstein",
  "block.minecraft.prismarine_slab": "Prismarienplaat",
  "block.minecraft.prismarine_stairs": "Prismarien traeje",
  "block.minecraft.prismarine_wall": "Prismarienmoer",
  "block.minecraft.pumpkin": "Pompoen",
  "block.minecraft.pumpkin_stem": "Pompoensjtam",
  "block.minecraft.purple_banner": "Paarse banier",
  "block.minecraft.purple_bed": "Paars bèd",
  "block.minecraft.purple_candle": "Paarse kaars",
  "block.minecraft.purple_candle_cake": "Taart met paarse kaars",
  "block.minecraft.purple_carpet": "Paars Kerpèt",
  "block.minecraft.purple_concrete": "Paars beton",
  "block.minecraft.purple_concrete_powder": "Paars cement",
  "block.minecraft.purple_glazed_terracotta": "Paarsgeglazuurde terracotta",
  "block.minecraft.purple_shulker_box": "Paarse Shulkerdoeas",
  "block.minecraft.purple_stained_glass": "Paars gekleurd glaas",
  "block.minecraft.purple_stained_glass_pane": "Paars gekleurde glazen roet",
  "block.minecraft.purple_terracotta": "Paorse Terracotta",
  "block.minecraft.purple_wool": "Paarse wol",
  "block.minecraft.purpur_block": "Purpurblok",
  "block.minecraft.purpur_pillar": "Purpurpillaar",
  "block.minecraft.purpur_slab": "Purpurplaat",
  "block.minecraft.purpur_stairs": "Purpur traeje",
  "block.minecraft.quartz_block": "Kwartsblok",
  "block.minecraft.quartz_bricks": "Kwartsbakstein",
  "block.minecraft.quartz_pillar": "Kwarts pillaar",
  "block.minecraft.quartz_slab": "Kwartsplaat",
  "block.minecraft.quartz_stairs": "Kwarts traeje",
  "block.minecraft.rail": "Rail",
  "block.minecraft.raw_copper_block": "Ruw kauperblok",
  "block.minecraft.raw_gold_block": "Ruw goldblok",
  "block.minecraft.raw_iron_block": "Ruw iezerblok",
  "block.minecraft.red_banner": "Roede banier",
  "block.minecraft.red_bed": "Roed bèd",
  "block.minecraft.red_candle": "Roeie kaars",
  "block.minecraft.red_candle_cake": "Taart met roeie kaars",
  "block.minecraft.red_carpet": "Roed Kerpèt",
  "block.minecraft.red_concrete": "Roead beton",
  "block.minecraft.red_concrete_powder": "Roed cement",
  "block.minecraft.red_glazed_terracotta": "Roeadgeglazuurde terracotta",
  "block.minecraft.red_mushroom": "Roeje paddesjtool",
  "block.minecraft.red_mushroom_block": "Roed paddenstoelenblok",
  "block.minecraft.red_nether_brick_slab": "Roede Netherbaksteinen plaat",
  "block.minecraft.red_nether_brick_stairs": "Roede Netherbakstein traeje",
  "block.minecraft.red_nether_brick_wall": "Roede Netherbakstein moor",
  "block.minecraft.red_nether_bricks": "Roede Netherbakstein",
  "block.minecraft.red_sand": "Roed Zandj",
  "block.minecraft.red_sandstone": "Roeje zandstein",
  "block.minecraft.red_sandstone_slab": "Roeje zandsteine plaat",
  "block.minecraft.red_sandstone_stairs": "Roeje zandstein traeje",
  "block.minecraft.red_sandstone_wall": "Roede zandsjteinen moer",
  "block.minecraft.red_shulker_box": "Roeje Shulkerdoeas",
  "block.minecraft.red_stained_glass": "Roed gekleurde glaas",
  "block.minecraft.red_stained_glass_pane": "Roed gekleurde glazen roet",
  "block.minecraft.red_terracotta": "Roeke Terracotta",
  "block.minecraft.red_tulip": "Roede tulp",
  "block.minecraft.red_wool": "Roeje wol",
  "block.minecraft.redstone_block": "Redstoneblok",
  "block.minecraft.redstone_lamp": "Redstonelamp",
  "block.minecraft.redstone_ore": "Redstone-erts",
  "block.minecraft.redstone_torch": "Redstone fakkel",
  "block.minecraft.redstone_wall_torch": "Redstonefakkel aan moor",
  "block.minecraft.redstone_wire": "Redstonedraod",
  "block.minecraft.reinforced_deepslate": "Gewapend deepleistein",
  "block.minecraft.repeater": "Redstoneversterker",
  "block.minecraft.repeating_command_block": "Herhaolend opdrachblok",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Herspawnanker",
  "block.minecraft.rooted_dirt": "Geworteld drek",
  "block.minecraft.rose_bush": "Roeaze stroek",
  "block.minecraft.sand": "Zandj",
  "block.minecraft.sandstone": "Zandstein",
  "block.minecraft.sandstone_slab": "Zandsteine plaat",
  "block.minecraft.sandstone_stairs": "Zandstein traeje",
  "block.minecraft.sandstone_wall": "Zandsjteinen moer",
  "block.minecraft.scaffolding": "Sjtèlling",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkatalysator",
  "block.minecraft.sculk_sensor": "Sculksensor",
  "block.minecraft.sculk_shrieker": "Sculkkrieser",
  "block.minecraft.sculk_vein": "Sculkaor",
  "block.minecraft.sea_lantern": "Ziëlantaarn",
  "block.minecraft.sea_pickle": "Ziëaugurk",
  "block.minecraft.seagrass": "Ziëgraas",
  "block.minecraft.set_spawn": "Herspawn punt gezatte",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Zwammenleecht",
  "block.minecraft.shulker_box": "Shulkerdoeas",
  "block.minecraft.skeleton_skull": "Skelettenschedel",
  "block.minecraft.skeleton_wall_skull": "Skelettenschedel aon moer",
  "block.minecraft.slime_block": "Sliémblok",
  "block.minecraft.small_amethyst_bud": "Kleine amethistknöp",
  "block.minecraft.small_dripleaf": "Kleine druppelblaad",
  "block.minecraft.smithing_table": "Smeedstaofel",
  "block.minecraft.smoker": "Rouker",
  "block.minecraft.smooth_basalt": "Gladde basalt",
  "block.minecraft.smooth_quartz": "Gladde kwartsblok",
  "block.minecraft.smooth_quartz_slab": "Gladde kwartsplaat",
  "block.minecraft.smooth_quartz_stairs": "Gladde kwarts traeje",
  "block.minecraft.smooth_red_sandstone": "Gladde roeje zandstein",
  "block.minecraft.smooth_red_sandstone_slab": "Gladde roede zandsjteinen plaat",
  "block.minecraft.smooth_red_sandstone_stairs": "Gladde roede zandstein traeje",
  "block.minecraft.smooth_sandstone": "Gladde zandstein",
  "block.minecraft.smooth_sandstone_slab": "Gladde zandsjteinen plaat",
  "block.minecraft.smooth_sandstone_stairs": "Gladde zandstein traeje",
  "block.minecraft.smooth_stone": "Gladde stein",
  "block.minecraft.smooth_stone_slab": "Gladde steine plaat",
  "block.minecraft.sniffer_egg": "Snuffelaersei",
  "block.minecraft.snow": "Sjnie",
  "block.minecraft.snow_block": "Snie blok",
  "block.minecraft.soul_campfire": "Zielenkampveur",
  "block.minecraft.soul_fire": "Ziel veur",
  "block.minecraft.soul_lantern": "Zielenlantaarn",
  "block.minecraft.soul_sand": "Zeelzandj",
  "block.minecraft.soul_soil": "Zielenaarde",
  "block.minecraft.soul_torch": "Zeielenfakkel",
  "block.minecraft.soul_wall_torch": "Zielenfakkel aan moor",
  "block.minecraft.spawn.not_valid": "De hebs gen thoes bed of opgelaode herspawnanker, of 't waas belimmerd",
  "block.minecraft.spawner": "Monsterspawner",
  "block.minecraft.spawner.desc1": "Interactie met spawnei:",
  "block.minecraft.spawner.desc2": "Bepaolt te spawne waeze type",
  "block.minecraft.sponge": "Sjpóns",
  "block.minecraft.spore_blossom": "Sporenbloesem",
  "block.minecraft.spruce_button": "Sjparre Knop",
  "block.minecraft.spruce_door": "Sparrenhoute duuer",
  "block.minecraft.spruce_fence": "Sparrenhouten hek",
  "block.minecraft.spruce_fence_gate": "Sparrenhouten peurtje",
  "block.minecraft.spruce_hanging_sign": "Sjparrenhouten hangbord",
  "block.minecraft.spruce_leaves": "Sparrennaoldje",
  "block.minecraft.spruce_log": "Sparrenstjam",
  "block.minecraft.spruce_planks": "Sparrenhouten plenk",
  "block.minecraft.spruce_pressure_plate": "Sjparrehoute Drukplaat",
  "block.minecraft.spruce_sapling": "Sparrenkiemplant",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Sjparrenhouten bord",
  "block.minecraft.spruce_slab": "Sparrenhouten plaat",
  "block.minecraft.spruce_stairs": "Sparrenhoute traeje",
  "block.minecraft.spruce_trapdoor": "Sparrehouten valloek",
  "block.minecraft.spruce_wall_hanging_sign": "Sjparrenhouten oethangbord",
  "block.minecraft.spruce_wall_sign": "Sjparrenhoutenbord aon moor",
  "block.minecraft.spruce_wood": "Sjparrehout",
  "block.minecraft.sticky_piston": "Kleefzuiger",
  "block.minecraft.stone": "Stein",
  "block.minecraft.stone_brick_slab": "Blokstein plaat",
  "block.minecraft.stone_brick_stairs": "Blokstein traeje",
  "block.minecraft.stone_brick_wall": "Bloksteinen moor",
  "block.minecraft.stone_bricks": "Bloksteinen",
  "block.minecraft.stone_button": "Steine knop",
  "block.minecraft.stone_pressure_plate": "Steinen drukplaat",
  "block.minecraft.stone_slab": "Steinen plaat",
  "block.minecraft.stone_stairs": "Steine traeje",
  "block.minecraft.stonecutter": "Steinzaag",
  "block.minecraft.stripped_acacia_log": "Gestripte Acaciasjtam",
  "block.minecraft.stripped_acacia_wood": "Gestript acaciahout",
  "block.minecraft.stripped_bamboo_block": "Gestript bamboeblok",
  "block.minecraft.stripped_birch_log": "Gestripte Berkesjtam",
  "block.minecraft.stripped_birch_wood": "Gestript berkehout",
  "block.minecraft.stripped_cherry_log": "Gestripte keseboumstam",
  "block.minecraft.stripped_cherry_wood": "Gestript kesehout",
  "block.minecraft.stripped_crimson_hyphae": "Gestripte helroede schimmeldraod",
  "block.minecraft.stripped_crimson_stem": "Gestripte helroede stem",
  "block.minecraft.stripped_dark_oak_log": "Gestripte Donkere Eikensjtam",
  "block.minecraft.stripped_dark_oak_wood": "Gestript donkereikehout",
  "block.minecraft.stripped_jungle_log": "Gestripte Oerwoudsjtam",
  "block.minecraft.stripped_jungle_wood": "Gestript oerwoudhout",
  "block.minecraft.stripped_mangrove_log": "Gestripte mangrovestam",
  "block.minecraft.stripped_mangrove_wood": "Gestript mangrovehout",
  "block.minecraft.stripped_oak_log": "Gestripte Eikesjtam",
  "block.minecraft.stripped_oak_wood": "Gestript eikehout",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Gestripte Sjparresjtam",
  "block.minecraft.stripped_spruce_wood": "Gestript sjparrehout",
  "block.minecraft.stripped_warped_hyphae": "Gestripte spoekachtige schimmeldraod",
  "block.minecraft.stripped_warped_stem": "Gestripte spoekachtige stem",
  "block.minecraft.structure_block": "Structuurblok",
  "block.minecraft.structure_void": "Structuurleagte",
  "block.minecraft.sugar_cane": "Soekër Sjtek",
  "block.minecraft.sunflower": "Zónnebloom",
  "block.minecraft.suspicious_gravel": "Verdach grind",
  "block.minecraft.suspicious_sand": "Verdach zand",
  "block.minecraft.sweet_berry_bush": "Zeutbesstroek",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Hoog graas",
  "block.minecraft.tall_seagrass": "Hoeg ziëgraas",
  "block.minecraft.target": "Doelwit",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Getint glaas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Fakkelbloom",
  "block.minecraft.torchflower_crop": "Fakkelbloomgewas",
  "block.minecraft.trapped_chest": "Kis mit Val",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "Stroekeldraod",
  "block.minecraft.tripwire_hook": "Stroekeldraodhaak",
  "block.minecraft.tube_coral": "Buuskoraal",
  "block.minecraft.tube_coral_block": "Buuskoraalblok",
  "block.minecraft.tube_coral_fan": "Buuskoraalwaaijer",
  "block.minecraft.tube_coral_wall_fan": "Buiskoraalwaaier aon moer",
  "block.minecraft.tuff": "Tufstein",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "Sjildkróddel ei",
  "block.minecraft.twisting_vines": "Dreiende lianen",
  "block.minecraft.twisting_vines_plant": "Dreiende liaanplant",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "Greun kwakkerleecht",
  "block.minecraft.vine": "Lianen",
  "block.minecraft.void_air": "Nurgens loch",
  "block.minecraft.wall_torch": "Moer Fakkel",
  "block.minecraft.warped_button": "Spoekachtige houten knöp",
  "block.minecraft.warped_door": "Spoekachtige deur",
  "block.minecraft.warped_fence": "Spoekachtige houten hek",
  "block.minecraft.warped_fence_gate": "Spoekachtig houten peurtje",
  "block.minecraft.warped_fungus": "Spoekachtige zwam",
  "block.minecraft.warped_hanging_sign": "Spoekachtige houten hangbord",
  "block.minecraft.warped_hyphae": "Spoekachtige schimmeldraod",
  "block.minecraft.warped_nylium": "Spoekachtig nylium",
  "block.minecraft.warped_planks": "Spoekachtige houten plenk",
  "block.minecraft.warped_pressure_plate": "Spoekachtige houten drukplaat",
  "block.minecraft.warped_roots": "Spoekachtige wortelle",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Spoekachtige houten bord",
  "block.minecraft.warped_slab": "Spoekachtige houten plaat",
  "block.minecraft.warped_stairs": "Spoekachtige houte traeje",
  "block.minecraft.warped_stem": "Spoekachtige stem",
  "block.minecraft.warped_trapdoor": "Spoekachtig houten valloek",
  "block.minecraft.warped_wall_hanging_sign": "Spoekachtige houten oethangbord",
  "block.minecraft.warped_wall_sign": "Spoekachtig boord aan moor",
  "block.minecraft.warped_wart_block": "Spoekachtig kruudblok",
  "block.minecraft.water": "Water",
  "block.minecraft.water_cauldron": "Water Kaetel",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Gewaxt kauperblok",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Gewaxt gesneeïen kauper",
  "block.minecraft.waxed_cut_copper_slab": "Gewaxt gesneeïen kauper plaat",
  "block.minecraft.waxed_cut_copper_stairs": "Ingewasse gesneeje kauper traeje",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "Gewaxt bloedgestelde kauper",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Gewaxt bloedgestelde gesneeïen kauper",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gewaxt bloedgestelde gesneeïen kauper plaat",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ingewasse bloetgestelde gesneeje kauper traeje",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "Gewaxt geoxideerd kauper",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Gewaxt geoxideerd gesneeïen kauper",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gewaxt geoxideerd gesneeïen kauper plaat",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Ingewasse geoxideerde gesneeje kauper traeje",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Gewaxt verwierd kauper",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Gewaxt verwierd gesneeïen kauper",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gewaxt verwierd gesneeïen kauper plaat",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Ingewasse verwierde gesneeje kauper traeje",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "Verwierd kauper",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Verwierd gesneeïen kauper",
  "block.minecraft.weathered_cut_copper_slab": "Verwierd gesneeïen kauper plaat",
  "block.minecraft.weathered_cut_copper_stairs": "Verwierd gesneeje kauper traeje",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Hangende lianen",
  "block.minecraft.weeping_vines_plant": "Hangende liaanplant",
  "block.minecraft.wet_sponge": "Natte sjpons",
  "block.minecraft.wheat": "Tarwe oogst",
  "block.minecraft.white_banner": "Witte banier",
  "block.minecraft.white_bed": "Wit bèd",
  "block.minecraft.white_candle": "Witte kaars",
  "block.minecraft.white_candle_cake": "Taart met witte kaars",
  "block.minecraft.white_carpet": "Wit Kerpèt",
  "block.minecraft.white_concrete": "Wit beton",
  "block.minecraft.white_concrete_powder": "Wit cement",
  "block.minecraft.white_glazed_terracotta": "Witgeglazuurde terracotta",
  "block.minecraft.white_shulker_box": "Witte Shulkerdoeas",
  "block.minecraft.white_stained_glass": "Wit gekleurd glaas",
  "block.minecraft.white_stained_glass_pane": "Witgekleurde glazen roet",
  "block.minecraft.white_terracotta": "Wit Terracotta",
  "block.minecraft.white_tulip": "Witte tulp",
  "block.minecraft.white_wool": "Witte wol",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Witherroes",
  "block.minecraft.wither_skeleton_skull": "Witherskelettenschedel",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskelettenschedel aon moer",
  "block.minecraft.yellow_banner": "Gaele banier",
  "block.minecraft.yellow_bed": "Gael bèd",
  "block.minecraft.yellow_candle": "Gaele kaars",
  "block.minecraft.yellow_candle_cake": "Taart met gaele kaars",
  "block.minecraft.yellow_carpet": "Gael Kerpèt",
  "block.minecraft.yellow_concrete": "Gael beton",
  "block.minecraft.yellow_concrete_powder": "Gael cement",
  "block.minecraft.yellow_glazed_terracotta": "Gaelgeglazuurde terracotta",
  "block.minecraft.yellow_shulker_box": "Gaele Shulkerdoeas",
  "block.minecraft.yellow_stained_glass": "Gael gekleurd glaas",
  "block.minecraft.yellow_stained_glass_pane": "Gael gekleurde glazen roet",
  "block.minecraft.yellow_terracotta": "Gaele Terracotta",
  "block.minecraft.yellow_wool": "Gaele wol",
  "block.minecraft.zombie_head": "Zombiehoofd",
  "block.minecraft.zombie_wall_head": "Zombiehoofd aon moer",
  "item.minecraft.acacia_boat": "Acaciahouten boeat",
  "item.minecraft.acacia_chest_boat": "Acaciahouten boeat met kis",
  "item.minecraft.allay_spawn_egg": "Helperspawnei",
  "item.minecraft.amethyst_shard": "Amethistscherf",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Aerdewerksjerf 'visser'",
  "item.minecraft.apple": "Appel",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Aerdewerksjerf 'baogsjötter'",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Harnashouder",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Aerdewerksjerf 'gehaeve erm'",
  "item.minecraft.arrow": "Piel",
  "item.minecraft.axolotl_bucket": "Tob met axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotlspawnei",
  "item.minecraft.baked_potato": "Gebakke aerpel",
  "item.minecraft.bamboo_chest_raft": "Bamboevlot met kis",
  "item.minecraft.bamboo_raft": "Bamboevlot",
  "item.minecraft.bat_spawn_egg": "Flaermoesspawnei",
  "item.minecraft.bee_spawn_egg": "Biejspawnei",
  "item.minecraft.beef": "Rauw bufsjtök",
  "item.minecraft.beetroot": "Biet",
  "item.minecraft.beetroot_seeds": "Bietenzoaden",
  "item.minecraft.beetroot_soup": "Bietensoep",
  "item.minecraft.birch_boat": "Birkehouten boeat",
  "item.minecraft.birch_chest_boat": "Birkehouten boeat met kis",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Zwarte kleursjtóf",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Aerdewerksjerf 'zjwaard'",
  "item.minecraft.blaze_powder": "Blaze poejer",
  "item.minecraft.blaze_rod": "Blaze sjtaaf",
  "item.minecraft.blaze_spawn_egg": "Blazespawnei",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Blauwe kleursjtóf",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Knaok",
  "item.minecraft.bone_meal": "Beendermeel",
  "item.minecraft.book": "Book",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Bäög",
  "item.minecraft.bowl": "Kom",
  "item.minecraft.bread": "Broed",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Aerdewerksjerf 'broewer'",
  "item.minecraft.brewing_stand": "Brouwstanderd",
  "item.minecraft.brick": "Bakstein",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Broene kleursjtóf",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Borstel",
  "item.minecraft.bucket": "Tob",
  "item.minecraft.bundle": "Bundel",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Aerdewerksjerf 'branje'",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Dromedarisspawnei",
  "item.minecraft.carrot": "Wórtel",
  "item.minecraft.carrot_on_a_stick": "Wortel op een stek",
  "item.minecraft.cat_spawn_egg": "Kattenspawnei",
  "item.minecraft.cauldron": "Kaetel",
  "item.minecraft.cave_spider_spawn_egg": "Grottenspinnenspawnei",
  "item.minecraft.chainmail_boots": "Maliënlaarzen",
  "item.minecraft.chainmail_chestplate": "Maliënkolder",
  "item.minecraft.chainmail_helmet": "Maliënkap",
  "item.minecraft.chainmail_leggings": "Maliënbóks",
  "item.minecraft.charcoal": "Houtskaol",
  "item.minecraft.cherry_boat": "Kesehouten boeat",
  "item.minecraft.cherry_chest_boat": "Kesehouten boeat met kis",
  "item.minecraft.chest_minecart": "Mienkar mit kis",
  "item.minecraft.chicken": "Rauw Hin",
  "item.minecraft.chicken_spawn_egg": "Kippespawnei",
  "item.minecraft.chorus_fruit": "Chorusfruit",
  "item.minecraft.clay_ball": "Kliébal",
  "item.minecraft.clock": "Klok",
  "item.minecraft.coal": "Sjteinkaol",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Cacaobonen",
  "item.minecraft.cod": "Rauwe Kabeljauw",
  "item.minecraft.cod_bucket": "Tob mit kabeljauw",
  "item.minecraft.cod_spawn_egg": "Kabeljauwspawnei",
  "item.minecraft.command_block_minecart": "Mienkar mit opdrachblok",
  "item.minecraft.compass": "Kómpas",
  "item.minecraft.cooked_beef": "Bufsjtök",
  "item.minecraft.cooked_chicken": "Gekaokde kiep",
  "item.minecraft.cooked_cod": "Gekoakte kabeljauw",
  "item.minecraft.cooked_mutton": "Gebraoje sjaopevleis",
  "item.minecraft.cooked_porkchop": "Gekaok verkesvleisj",
  "item.minecraft.cooked_rabbit": "Gebraoje kenienvleisj",
  "item.minecraft.cooked_salmon": "Gekoakte zalm",
  "item.minecraft.cookie": "Koekje",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Kauperstaaf",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Kospawnei",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Banierpatroen",
  "item.minecraft.creeper_banner_pattern.desc": "Creeperwapen",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Creeperspawnei",
  "item.minecraft.crossbow": "Kruutsbaog",
  "item.minecraft.crossbow.projectile": "Projectiel:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Turquoise Kleurstof",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Aerdewerksjerf 'gevaor'",
  "item.minecraft.dark_oak_boat": "Donkereikenhouten boeat",
  "item.minecraft.dark_oak_chest_boat": "Donkereikenhouten boeat met kis",
  "item.minecraft.debug_stick": "Debugsjtek",
  "item.minecraft.debug_stick.empty": "%s haet geen eigenschappen",
  "item.minecraft.debug_stick.select": "'%s' geselecteerd (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" nao %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamant biel",
  "item.minecraft.diamond_boots": "Diamante laarzen",
  "item.minecraft.diamond_chestplate": "Diamante borstplaat",
  "item.minecraft.diamond_helmet": "Diamante helm",
  "item.minecraft.diamond_hoe": "Diamante sjoffel",
  "item.minecraft.diamond_horse_armor": "Diamante paerdeharnas",
  "item.minecraft.diamond_leggings": "Diamante beinstukken",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Diamante bikkel",
  "item.minecraft.diamond_shovel": "Diamante sjöp",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Diamante zjwaard",
  "item.minecraft.disc_fragment_5": "Meziekplaatfragment",
  "item.minecraft.disc_fragment_5.desc": "Meziekplaat - 5",
  "item.minecraft.dolphin_spawn_egg": "Dolfijnenspawnei",
  "item.minecraft.donkey_spawn_egg": "Aezelspawnei",
  "item.minecraft.dragon_breath": "Drakenaom",
  "item.minecraft.dried_kelp": "Gedrüugde kelp",
  "item.minecraft.drowned_spawn_egg": "Drenkelingenspawnei",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Echosjerf",
  "item.minecraft.egg": "Ei",
  "item.minecraft.elder_guardian_spawn_egg": "Oudebewakerspawnei",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Betouverd book",
  "item.minecraft.enchanted_golden_apple": "Betoverde gouwe appel",
  "item.minecraft.end_crystal": "Endkristal",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdraakspawnei",
  "item.minecraft.ender_eye": "Enderoug",
  "item.minecraft.ender_pearl": "Enderpaerel",
  "item.minecraft.enderman_spawn_egg": "Endermannenspawnei",
  "item.minecraft.endermite_spawn_egg": "Endermitespawnei",
  "item.minecraft.evoker_spawn_egg": "Oproeperspawnei",
  "item.minecraft.experience_bottle": "Flesj der betouvering",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Aerdewerksjerf 'ontdekker'",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Vaer",
  "item.minecraft.fermented_spider_eye": "Gefermenteerd spinnenoug",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Kaart",
  "item.minecraft.fire_charge": "Vuurbal",
  "item.minecraft.firework_rocket": "Vuurpiel",
  "item.minecraft.firework_rocket.flight": "Vluchtduur:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Vuurwerksjter",
  "item.minecraft.firework_star.black": "Zjwart",
  "item.minecraft.firework_star.blue": "Blauw",
  "item.minecraft.firework_star.brown": "Broen",
  "item.minecraft.firework_star.custom_color": "Aangepast",
  "item.minecraft.firework_star.cyan": "Turquoise",
  "item.minecraft.firework_star.fade_to": "Overgang nao",
  "item.minecraft.firework_star.flicker": "Twinkel",
  "item.minecraft.firework_star.gray": "Gries",
  "item.minecraft.firework_star.green": "Greun",
  "item.minecraft.firework_star.light_blue": "Leechtblauw",
  "item.minecraft.firework_star.light_gray": "Leechtgries",
  "item.minecraft.firework_star.lime": "Limoengreun",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Oranje",
  "item.minecraft.firework_star.pink": "Roze",
  "item.minecraft.firework_star.purple": "Paars",
  "item.minecraft.firework_star.red": "Roed",
  "item.minecraft.firework_star.shape": "Onbekende vorm",
  "item.minecraft.firework_star.shape.burst": "Explosie",
  "item.minecraft.firework_star.shape.creeper": "Creepervormig",
  "item.minecraft.firework_star.shape.large_ball": "Groete bal",
  "item.minecraft.firework_star.shape.small_ball": "Kleine bal",
  "item.minecraft.firework_star.shape.star": "Sjtervormig",
  "item.minecraft.firework_star.trail": "Spoear",
  "item.minecraft.firework_star.white": "Wit",
  "item.minecraft.firework_star.yellow": "Gael",
  "item.minecraft.fishing_rod": "Vèsgaert",
  "item.minecraft.flint": "Vuursjtein",
  "item.minecraft.flint_and_steel": "Vuursjtein en sjtaol",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banierpatroen",
  "item.minecraft.flower_banner_pattern.desc": "Bloomwapen",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Bloompot",
  "item.minecraft.fox_spawn_egg": "Vossespawnei",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Aerdewerksjerf 'vrind'",
  "item.minecraft.frog_spawn_egg": "Kwakkertspawnei",
  "item.minecraft.furnace_minecart": "Mienkar mit aove",
  "item.minecraft.ghast_spawn_egg": "Ghastspawnei",
  "item.minecraft.ghast_tear": "Ghast traon",
  "item.minecraft.glass_bottle": "Glaas fles",
  "item.minecraft.glistering_melon_slice": "Glinsterende meloensjief",
  "item.minecraft.globe_banner_pattern": "Banierpatroen",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Gloeibesse",
  "item.minecraft.glow_ink_sac": "Gloeiende inktvèsje",
  "item.minecraft.glow_item_frame": "Gloeiende veurwerpkader",
  "item.minecraft.glow_squid_spawn_egg": "Gloeiendeinktvèsjespawnei",
  "item.minecraft.glowstone_dust": "Gloeisteinstùf",
  "item.minecraft.goat_horn": "Geitehoorn",
  "item.minecraft.goat_spawn_egg": "Geitenspawnei",
  "item.minecraft.gold_ingot": "Goudstaaf",
  "item.minecraft.gold_nugget": "Goudklompje",
  "item.minecraft.golden_apple": "Gouwe appel",
  "item.minecraft.golden_axe": "Goude Biel",
  "item.minecraft.golden_boots": "Gouden laarzen",
  "item.minecraft.golden_carrot": "Gouwe wortel",
  "item.minecraft.golden_chestplate": "Gouden borstplaat",
  "item.minecraft.golden_helmet": "Gouden helm",
  "item.minecraft.golden_hoe": "Gouden sjoffel",
  "item.minecraft.golden_horse_armor": "Gouwe paerdeharnas",
  "item.minecraft.golden_leggings": "Gouden beinstukken",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Goude Bikkel",
  "item.minecraft.golden_shovel": "Goude Sjöp",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Goude zjwaard",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Gries kleurstof",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Greune kleursjtóf",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Bewakerspawnei",
  "item.minecraft.gunpowder": "Buskroet",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Hert van de zië",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Aerdewerksjerf 'hert'",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Aerdewerksjerf 'gebraoke hert'",
  "item.minecraft.hoglin_spawn_egg": "Hoglinspawnei",
  "item.minecraft.honey_bottle": "Höning fleske",
  "item.minecraft.honeycomb": "Höningraat",
  "item.minecraft.hopper_minecart": "Mienkar mit trechter",
  "item.minecraft.horse_spawn_egg": "Paerdespawnei",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Aerdewerksjerf 'bäöke'",
  "item.minecraft.husk_spawn_egg": "Mummiespawnei",
  "item.minecraft.ink_sac": "Inkttes",
  "item.minecraft.iron_axe": "Iezer Biel",
  "item.minecraft.iron_boots": "Iezere laarzen",
  "item.minecraft.iron_chestplate": "Iezere borsplaat",
  "item.minecraft.iron_golem_spawn_egg": "Iezeregolemspawnei",
  "item.minecraft.iron_helmet": "Iezere helm",
  "item.minecraft.iron_hoe": "Iezere sjoffel",
  "item.minecraft.iron_horse_armor": "Iezere paerdeharnas",
  "item.minecraft.iron_ingot": "Iezerstaaf",
  "item.minecraft.iron_leggings": "Iezere beinstukke",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Iezerklumpke",
  "item.minecraft.iron_pickaxe": "Iezer Bikkel",
  "item.minecraft.iron_shovel": "Iezer sjöp",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Iezer Zjwaard",
  "item.minecraft.item_frame": "Voorwerpliest",
  "item.minecraft.jungle_boat": "Oerwoudhouten boeat",
  "item.minecraft.jungle_chest_boat": "Oerwoudhouten boeat met kis",
  "item.minecraft.knowledge_book": "Book der kennis",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Tob lava",
  "item.minecraft.lead": "Leidtuike",
  "item.minecraft.leather": "Leer",
  "item.minecraft.leather_boots": "Laere laarzen",
  "item.minecraft.leather_chestplate": "Laere tuniek",
  "item.minecraft.leather_helmet": "Laere kap",
  "item.minecraft.leather_horse_armor": "Lieëre Paerden Sjild",
  "item.minecraft.leather_leggings": "Laere bóks",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Leechtblauwe kleurstof",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Leechtgrieze kleurstof",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Limoengreun kleurstof",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Aanhoudende drank",
  "item.minecraft.lingering_potion.effect.awkward": "Aanhoudend vreemd drenkske",
  "item.minecraft.lingering_potion.effect.empty": "Aanhoudend onmaakbaar drenkske",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Aanhoudende Drank der Vuurbesjtendighied",
  "item.minecraft.lingering_potion.effect.harming": "Aanhoudende drank der verwonding",
  "item.minecraft.lingering_potion.effect.healing": "Aanhoudende drank der genezing",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Aanhoudende Drank der Onzichtbaarheid",
  "item.minecraft.lingering_potion.effect.leaping": "Aanhoudende drank der sjprongen",
  "item.minecraft.lingering_potion.effect.levitation": "Aanhoudende Drank der Zjweving",
  "item.minecraft.lingering_potion.effect.luck": "Aanhoudende drank des geluks",
  "item.minecraft.lingering_potion.effect.mundane": "Aanhoudend triviaal drenkske",
  "item.minecraft.lingering_potion.effect.night_vision": "Aanhoudende Drank der Nachtzicht",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Aanhoudende drank der vergif",
  "item.minecraft.lingering_potion.effect.regeneration": "Aanhoudende Drank der Regeneratie",
  "item.minecraft.lingering_potion.effect.slow_falling": "Aanhoudende drank der valvertraging",
  "item.minecraft.lingering_potion.effect.slowness": "Aanhoudende drank der traaghied",
  "item.minecraft.lingering_potion.effect.strength": "Aanhoudende drank der kracht",
  "item.minecraft.lingering_potion.effect.swiftness": "Aanhoudende Drank der Sjnelhied",
  "item.minecraft.lingering_potion.effect.thick": "Aanhoudende stroperige drank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Aanhoudende drank van de sjildkróddelmeester",
  "item.minecraft.lingering_potion.effect.water": "Aanhoudende waterflesj",
  "item.minecraft.lingering_potion.effect.water_breathing": "Aanhoudende Drank der Wateraodem",
  "item.minecraft.lingering_potion.effect.weakness": "Aanhoudende drank der zwakheid",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Lamaspawnei",
  "item.minecraft.lodestone_compass": "Kompas wiezend naor zeilstein",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Magenta kleurstof",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Magmacrème",
  "item.minecraft.magma_cube_spawn_egg": "Magmakubesspawnei",
  "item.minecraft.mangrove_boat": "Mangrovehouten boeat",
  "item.minecraft.mangrove_chest_boat": "Mangrovehouten boeat met kis",
  "item.minecraft.map": "Laege kaart",
  "item.minecraft.melon_seeds": "Meloenzoaden",
  "item.minecraft.melon_slice": "Meloenschijf",
  "item.minecraft.milk_bucket": "Tob melk",
  "item.minecraft.minecart": "Mienkar",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Aerdewerksjerf 'mienwirker'",
  "item.minecraft.mojang_banner_pattern": "Banierpatroen",
  "item.minecraft.mojang_banner_pattern.desc": "Mojangwapen",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroomspawnei",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Aerdewerksjerf 'roew'",
  "item.minecraft.mule_spawn_egg": "Muilaezelspawnei",
  "item.minecraft.mushroom_stew": "Paddestoel sop",
  "item.minecraft.music_disc_11": "Meziekplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Meziekplaat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Meziekplaat",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Meziekplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Meziekplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Meziekplaat",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Meziekplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Meziekplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Meziekplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Meziekplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Meziekplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Meziekplaat",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Meziekplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Meziekplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Meziekplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Meziekplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rauw Sjaopevleisj",
  "item.minecraft.name_tag": "Naamkaartje",
  "item.minecraft.nautilus_shell": "Nautilussjölp",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Netherbakstein",
  "item.minecraft.nether_star": "Netherster",
  "item.minecraft.nether_wart": "Netherkroed",
  "item.minecraft.netherite_axe": "Netherieten biel",
  "item.minecraft.netherite_boots": "Netherieten laars",
  "item.minecraft.netherite_chestplate": "Netherieten borstplaat",
  "item.minecraft.netherite_helmet": "Netherieten helm",
  "item.minecraft.netherite_hoe": "Netherieten schuffel",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netherietstaaf",
  "item.minecraft.netherite_leggings": "Netherieten boks",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Netherieten houwiel",
  "item.minecraft.netherite_scrap": "Netherietschroet",
  "item.minecraft.netherite_shovel": "Netherieten schup",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netherieten zwaard",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Eikehouten boeat",
  "item.minecraft.oak_chest_boat": "Eikehouten boeat met kis",
  "item.minecraft.ocelot_spawn_egg": "Ocelottenspawnei",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Oranje kleurstof",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Sjilderie",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Pandaspawnei",
  "item.minecraft.paper": "Pepeer",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Pappegaejespawnei",
  "item.minecraft.phantom_membrane": "Fantoommembraan",
  "item.minecraft.phantom_spawn_egg": "Fantomenspawnei",
  "item.minecraft.pig_spawn_egg": "Verkespawnei",
  "item.minecraft.piglin_banner_pattern": "Banierpatroen",
  "item.minecraft.piglin_banner_pattern.desc": "Snoet",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Piglinbruutspawnei",
  "item.minecraft.piglin_spawn_egg": "Piglinspawnei",
  "item.minecraft.pillager_spawn_egg": "Roverspawnei",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Roze kleurstof",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Baekerplant",
  "item.minecraft.pitcher_pod": "Baekerplantbaeker",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Aerdewerksjerf 'euvervloed'",
  "item.minecraft.poisonous_potato": "Vergiftige aerpel",
  "item.minecraft.polar_bear_spawn_egg": "Iesbaerespawnei",
  "item.minecraft.popped_chorus_fruit": "Gepoft Chorusfruit",
  "item.minecraft.porkchop": "Rauw verkesvleisj",
  "item.minecraft.potato": "Aerpel",
  "item.minecraft.potion": "Drank",
  "item.minecraft.potion.effect.awkward": "Vreemde drank",
  "item.minecraft.potion.effect.empty": "Onmaakbare drank",
  "item.minecraft.potion.effect.fire_resistance": "Drank der vuurbesjtendighied",
  "item.minecraft.potion.effect.harming": "Drank der verwonding",
  "item.minecraft.potion.effect.healing": "Drank der genaeshied",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Drank der onzichtbaarheid",
  "item.minecraft.potion.effect.leaping": "Drank der sjprongen",
  "item.minecraft.potion.effect.levitation": "Drank der zjweving",
  "item.minecraft.potion.effect.luck": "Drank der gelök",
  "item.minecraft.potion.effect.mundane": "Triviale drank",
  "item.minecraft.potion.effect.night_vision": "Drank der nachtzicht",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Drank des gifs",
  "item.minecraft.potion.effect.regeneration": "Drank der regeneratie",
  "item.minecraft.potion.effect.slow_falling": "Drank der valvertraging",
  "item.minecraft.potion.effect.slowness": "Drank der traaghied",
  "item.minecraft.potion.effect.strength": "Drank der sjterkte",
  "item.minecraft.potion.effect.swiftness": "Drank der sjnelhied",
  "item.minecraft.potion.effect.thick": "Stroperige drank",
  "item.minecraft.potion.effect.turtle_master": "Drank van de sjildkróddelmeester",
  "item.minecraft.potion.effect.water": "Waterflesj",
  "item.minecraft.potion.effect.water_breathing": "Drank der wateraodem",
  "item.minecraft.potion.effect.weakness": "Drank der zwakhied",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "Tob poeijersjnie",
  "item.minecraft.prismarine_crystals": "Prismarienkristallen",
  "item.minecraft.prismarine_shard": "Prismariensjerf",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Aerdewerksjerf 'pries'",
  "item.minecraft.pufferfish": "Keugelvès",
  "item.minecraft.pufferfish_bucket": "Tob mit keugelvès",
  "item.minecraft.pufferfish_spawn_egg": "Keugelvèsespawnei",
  "item.minecraft.pumpkin_pie": "Pompoentoert",
  "item.minecraft.pumpkin_seeds": "Pompoenpitten",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Paarse kleurstof",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Netherkwarts",
  "item.minecraft.rabbit": "Rauw kenienevleisj",
  "item.minecraft.rabbit_foot": "Kenienepuuetje",
  "item.minecraft.rabbit_hide": "Kenienehoed",
  "item.minecraft.rabbit_spawn_egg": "Kenienespawnei",
  "item.minecraft.rabbit_stew": "Kenienestoofpot",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Verwoesterspawnei",
  "item.minecraft.raw_copper": "Ruw kauper",
  "item.minecraft.raw_gold": "Ruw gold",
  "item.minecraft.raw_iron": "Ruw iezer",
  "item.minecraft.recovery_compass": "Herstelkompas",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Roede kleursjtóf",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Redstonestùf",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Gerot vleisj",
  "item.minecraft.saddle": "Zaal",
  "item.minecraft.salmon": "Rauwe zalm",
  "item.minecraft.salmon_bucket": "Tob mit zalm",
  "item.minecraft.salmon_spawn_egg": "Zalmspawnei",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Aerdewerksjerf 'schoef'",
  "item.minecraft.shears": "Sjier",
  "item.minecraft.sheep_spawn_egg": "Sjaopespawnei",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Aerdewerksjerf 'sjoelplaats'",
  "item.minecraft.shield": "Sjild",
  "item.minecraft.shield.black": "Zjwart sjild",
  "item.minecraft.shield.blue": "Blauw sjild",
  "item.minecraft.shield.brown": "Broen sjild",
  "item.minecraft.shield.cyan": "Turquoise sjild",
  "item.minecraft.shield.gray": "Gries sjild",
  "item.minecraft.shield.green": "Greun sjild",
  "item.minecraft.shield.light_blue": "Leechtblauw sjild",
  "item.minecraft.shield.light_gray": "Leechtgries sjild",
  "item.minecraft.shield.lime": "Limoengreun sjild",
  "item.minecraft.shield.magenta": "Magenta sjild",
  "item.minecraft.shield.orange": "Oranje sjild",
  "item.minecraft.shield.pink": "Roze sjild",
  "item.minecraft.shield.purple": "Paars sjild",
  "item.minecraft.shield.red": "Roed sjild",
  "item.minecraft.shield.white": "Wit sjild",
  "item.minecraft.shield.yellow": "Gael sjild",
  "item.minecraft.shulker_shell": "Shulkerschelp",
  "item.minecraft.shulker_spawn_egg": "Shulkerspawnei",
  "item.minecraft.sign": "Bord",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Zilvervèsjespawnei",
  "item.minecraft.skeleton_horse_spawn_egg": "Skeletpaerdespawnei",
  "item.minecraft.skeleton_spawn_egg": "Skelettenspawnei",
  "item.minecraft.skull_banner_pattern": "Banierpatroen",
  "item.minecraft.skull_banner_pattern.desc": "Schedelwapen",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Aerdewerksjerf 'schedel'",
  "item.minecraft.slime_ball": "Sliémbal",
  "item.minecraft.slime_spawn_egg": "Sliémkubesspawnei",
  "item.minecraft.smithing_template": "Smeedssjabloon",
  "item.minecraft.smithing_template.applies_to": "Van toepassing op:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Staaf of kristal toevoge",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Harnas",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Harnasstuk toevoge",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Staave en kristalle",
  "item.minecraft.smithing_template.ingredients": "Ingrediënte:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netherietstaaf toevoge",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamante oetrusting",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Diamanten harnas, waape of gereidschap toevoge",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherietstaaf",
  "item.minecraft.smithing_template.upgrade": "Upgrade(s): ",
  "item.minecraft.sniffer_spawn_egg": "Snuffelaerspawnei",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Aerdewerksjerf 'snuffele'",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Sjniegolemspawnei",
  "item.minecraft.snowball": "Sjniebal",
  "item.minecraft.spectral_arrow": "Spectrale piel",
  "item.minecraft.spider_eye": "Spinnenoug",
  "item.minecraft.spider_spawn_egg": "Spinnenspawnei",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Spattende drank",
  "item.minecraft.splash_potion.effect.awkward": "Spattende vreemde drank",
  "item.minecraft.splash_potion.effect.empty": "Spattend onmaakbaar drenkske",
  "item.minecraft.splash_potion.effect.fire_resistance": "Spattende Drank der Vuurbesjtendighiedat",
  "item.minecraft.splash_potion.effect.harming": "Spattende drank der verwonding",
  "item.minecraft.splash_potion.effect.healing": "Spattende drank der genaezing",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Spattende Drank der Onzichtbaarheid",
  "item.minecraft.splash_potion.effect.leaping": "Spattende drank der sjprongen",
  "item.minecraft.splash_potion.effect.levitation": "Spattende drank der zjweving",
  "item.minecraft.splash_potion.effect.luck": "Spattende drank der gelök",
  "item.minecraft.splash_potion.effect.mundane": "Spattende triviale drank",
  "item.minecraft.splash_potion.effect.night_vision": "Spattende Drank der Nachtzicht",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Spattende drank des gifs",
  "item.minecraft.splash_potion.effect.regeneration": "Spattende Drank der Regeneratie",
  "item.minecraft.splash_potion.effect.slow_falling": "Spattende drank der valvertraging",
  "item.minecraft.splash_potion.effect.slowness": "Spattende drank der traaghied",
  "item.minecraft.splash_potion.effect.strength": "Spattende drank der kracht",
  "item.minecraft.splash_potion.effect.swiftness": "Spattende drank der sjnelhied",
  "item.minecraft.splash_potion.effect.thick": "Spattende stroperige drank",
  "item.minecraft.splash_potion.effect.turtle_master": "Spattende drank van de sjildkróddelmeester",
  "item.minecraft.splash_potion.effect.water": "Spattende waterflesj",
  "item.minecraft.splash_potion.effect.water_breathing": "Spattende Drank der Wateraodem",
  "item.minecraft.splash_potion.effect.weakness": "Spattende drank der zwakhied",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Sparrehouten boeat",
  "item.minecraft.spruce_chest_boat": "Sparrehouten boeat met kis",
  "item.minecraft.spyglass": "Verrekieker",
  "item.minecraft.squid_spawn_egg": "Inktvèsjespawnei",
  "item.minecraft.stick": "Sjtek",
  "item.minecraft.stone_axe": "Sjtein Biel",
  "item.minecraft.stone_hoe": "Sjteine sjoffel",
  "item.minecraft.stone_pickaxe": "Sjtein Bikkel",
  "item.minecraft.stone_shovel": "Sjteine Sjöp",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Sjteine Zjwaard",
  "item.minecraft.stray_spawn_egg": "Verdwaaldenspawnei",
  "item.minecraft.strider_spawn_egg": "Lavariederspawnei",
  "item.minecraft.string": "Dräöj",
  "item.minecraft.sugar": "Soeker",
  "item.minecraft.suspicious_stew": "Geheimzinnige stoofpot",
  "item.minecraft.sweet_berries": "Zeutbessen",
  "item.minecraft.tadpole_bucket": "Emmer koelekop",
  "item.minecraft.tadpole_spawn_egg": "Koelekopspawnei",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Getipte piel",
  "item.minecraft.tipped_arrow.effect.awkward": "Getipte piel",
  "item.minecraft.tipped_arrow.effect.empty": "Onmaakbare getipte piel",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Piel der vuurbesjtendighied",
  "item.minecraft.tipped_arrow.effect.harming": "Piel der verwonding",
  "item.minecraft.tipped_arrow.effect.healing": "Piel der genezing",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Piel der onzichtbaarhied",
  "item.minecraft.tipped_arrow.effect.leaping": "Piel der sjprongen",
  "item.minecraft.tipped_arrow.effect.levitation": "Piel der zjweving",
  "item.minecraft.tipped_arrow.effect.luck": "Piel der gelök",
  "item.minecraft.tipped_arrow.effect.mundane": "Getipte piel",
  "item.minecraft.tipped_arrow.effect.night_vision": "Piel der nachtzichts",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Piel des gifs",
  "item.minecraft.tipped_arrow.effect.regeneration": "Piel der regeneratie",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Piel der valvertraging",
  "item.minecraft.tipped_arrow.effect.slowness": "Piel der traaghied",
  "item.minecraft.tipped_arrow.effect.strength": "Piel der kracht",
  "item.minecraft.tipped_arrow.effect.swiftness": "Piel der sjnelhied",
  "item.minecraft.tipped_arrow.effect.thick": "Getipte piel",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Piel van de sjildkróddelmeester",
  "item.minecraft.tipped_arrow.effect.water": "Piel der sjpatting",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Piel des wateraom",
  "item.minecraft.tipped_arrow.effect.weakness": "Piel der zwakhied",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Mienkar mit TNT",
  "item.minecraft.torchflower_seeds": "Fakkelbloemzaaije",
  "item.minecraft.totem_of_undying": "Totem der onsterfelijkhied",
  "item.minecraft.trader_llama_spawn_egg": "Hanjelaerslamaspawnei",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Dreejtand",
  "item.minecraft.tropical_fish": "Tropische vésj",
  "item.minecraft.tropical_fish_bucket": "Tob mit tropische vésj",
  "item.minecraft.tropical_fish_spawn_egg": "Tropischevèsjespawnei",
  "item.minecraft.turtle_helmet": "Sjildkróddelsjild",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Sjildkróddelespawnei",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Ergernissenspawnei",
  "item.minecraft.villager_spawn_egg": "Durpelingenspawnei",
  "item.minecraft.vindicator_spawn_egg": "Verdedigerspawnei",
  "item.minecraft.wandering_trader_spawn_egg": "Róndjreizendehanjelaerrsspawnei",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Hoederspawnei",
  "item.minecraft.warped_fungus_on_a_stick": "Spoekachtige zwam aan ein stukske",
  "item.minecraft.water_bucket": "Tob water",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Weit",
  "item.minecraft.wheat_seeds": "Tarwezaden",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Witter kleursjtóf",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Heksenspawnei",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelettenspawnei",
  "item.minecraft.wither_spawn_egg": "Witherspawnei",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "Wolvenspawnei",
  "item.minecraft.wooden_axe": "Hout Biel",
  "item.minecraft.wooden_hoe": "Houte sjoffel",
  "item.minecraft.wooden_pickaxe": "Houte Bikkel",
  "item.minecraft.wooden_shovel": "Houte Sjöp",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Houte Zjwaard",
  "item.minecraft.writable_book": "Book 'n vaer",
  "item.minecraft.written_book": "Geschreven book",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Gaele kleursjtóf",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglinspawnei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiepaerdespawnei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Zombiespawnei",
  "item.minecraft.zombie_villager_spawn_egg": "Zombiedorpelingenspawnei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombiepiglinspawnei"
}
export const li_li = items; 
